'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index = require('./index-4474431a.js');
const search_store = require('./search.store-f44567ad.js');
const _package = require('./package-2c27a669.js');
const index$1 = require('./index-1854036f.js');
const index$2 = require('./index-832a679e.js');
const triggerFilter = require('./triggerFilter-40a981b7.js');
const index$3 = require('./index-6d990fa6.js');

const BasketIcon = () => (index.h("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
  index.h("g", { id: "shopping-bag" },
    index.h("path", { id: "Vector", d: "M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V8C4 7.45 4.19583 6.97917 4.5875 6.5875C4.97917 6.19583 5.45 6 6 6H8C8 4.9 8.39167 3.95833 9.175 3.175C9.95833 2.39167 10.9 2 12 2C13.1 2 14.0417 2.39167 14.825 3.175C15.6083 3.95833 16 4.9 16 6H18C18.55 6 19.0208 6.19583 19.4125 6.5875C19.8042 6.97917 20 7.45 20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM6 20H18V8H16V10C16 10.2833 15.9042 10.5208 15.7125 10.7125C15.5208 10.9042 15.2833 11 15 11C14.7167 11 14.4792 10.9042 14.2875 10.7125C14.0958 10.5208 14 10.2833 14 10V8H10V10C10 10.2833 9.90417 10.5208 9.7125 10.7125C9.52083 10.9042 9.28333 11 9 11C8.71667 11 8.47917 10.9042 8.2875 10.7125C8.09583 10.5208 8 10.2833 8 10V8H6V20ZM10 6H14C14 5.45 13.8042 4.97917 13.4125 4.5875C13.0208 4.19583 12.55 4 12 4C11.45 4 10.9792 4.19583 10.5875 4.5875C10.1958 4.97917 10 5.45 10 6Z", fill: "#161616" }))));

const CheckCircleIcon = () => (index.h("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
  index.h("g", { id: "check" },
    index.h("path", { id: "Vector", d: "M10.6 13.8L8.45 11.65C8.26667 11.4667 8.03333 11.375 7.75 11.375C7.46667 11.375 7.23333 11.4667 7.05 11.65C6.86667 11.8333 6.775 12.0667 6.775 12.35C6.775 12.6333 6.86667 12.8667 7.05 13.05L9.9 15.9C10.1 16.1 10.3333 16.2 10.6 16.2C10.8667 16.2 11.1 16.1 11.3 15.9L16.95 10.25C17.1333 10.0667 17.225 9.83333 17.225 9.55C17.225 9.26667 17.1333 9.03333 16.95 8.85C16.7667 8.66667 16.5333 8.575 16.25 8.575C15.9667 8.575 15.7333 8.66667 15.55 8.85L10.6 13.8ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z", fill: "#16A34A" }))));

const ChevronIcon = () => (index.h("svg", { width: "9", height: "16", xmlns: "http://www.w3.org/2000/svg" },
  index.h("path", { d: "m9 8-7.895 8L0 14.88 6.79 8 0 1.12 1.105 0 9 8Z" })));

const UpdateIcon = () => (index.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
  index.h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M23.5998 4.57C20.3898 4.19 19.8798 3.68 19.4198 0.37C19.3798 0.15 19.2198 0 19.0098 0C18.7998 0 18.6298 0.15 18.5898 0.37C18.1198 3.66 17.6298 4.13 14.4098 4.57C14.1698 4.61 14.0098 4.77 14.0098 5C14.0098 5.23 14.1698 5.39 14.4098 5.42C17.6298 5.81 18.1398 6.31 18.5898 9.62C18.6298 9.84 18.7998 10 19.0098 10C19.2198 10 19.3898 9.84 19.4198 9.62C19.8898 6.31 20.3898 5.81 23.5998 5.42C23.8398 5.38 23.9998 5.22 23.9998 5C23.9998 4.78 23.8298 4.6 23.5998 4.57Z", fill: "currentColor" }),
  index.h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.93 13C19.43 13 19.01 13.37 18.95 13.86C18.52 17.36 15.51 20.06 11.89 20C8.24 19.94 5.15 16.92 5.01 13.27C4.92 10.79 6.13 8.58 8.01 7.27V11C8.01 11.55 8.46 12 9.01 12C9.56 12 10.01 11.55 10.01 11V5C10.01 4.45 9.56 4 9.01 4H3C2.45 4 2 4.45 2 5C2 5.55 2.45 6 3 6H6.35C4.24 7.71 2.91 10.35 3 13.3C3.15 17.98 7.06 21.87 11.74 22C16.45 22.13 20.37 18.65 20.93 14.13C21 13.53 20.53 13.01 19.93 13.01V13Z", fill: "currentColor" })));

const FiltersIcon = () => (index.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
  index.h("path", { d: "M12 21C11.7167 21 11.4792 20.9042 11.2875 20.7125C11.0958 20.5208 11 20.2833 11 20V16C11 15.7167 11.0958 15.4792 11.2875 15.2875C11.4792 15.0958 11.7167 15 12 15C12.2833 15 12.5208 15.0958 12.7125 15.2875C12.9042 15.4792 13 15.7167 13 16V17H20C20.2833 17 20.5208 17.0958 20.7125 17.2875C20.9042 17.4792 21 17.7167 21 18C21 18.2833 20.9042 18.5208 20.7125 18.7125C20.5208 18.9042 20.2833 19 20 19H13V20C13 20.2833 12.9042 20.5208 12.7125 20.7125C12.5208 20.9042 12.2833 21 12 21ZM4 19C3.71667 19 3.47917 18.9042 3.2875 18.7125C3.09583 18.5208 3 18.2833 3 18C3 17.7167 3.09583 17.4792 3.2875 17.2875C3.47917 17.0958 3.71667 17 4 17H8C8.28333 17 8.52083 17.0958 8.7125 17.2875C8.90417 17.4792 9 17.7167 9 18C9 18.2833 8.90417 18.5208 8.7125 18.7125C8.52083 18.9042 8.28333 19 8 19H4ZM8 15C7.71667 15 7.47917 14.9042 7.2875 14.7125C7.09583 14.5208 7 14.2833 7 14V13H4C3.71667 13 3.47917 12.9042 3.2875 12.7125C3.09583 12.5208 3 12.2833 3 12C3 11.7167 3.09583 11.4792 3.2875 11.2875C3.47917 11.0958 3.71667 11 4 11H7V10C7 9.71667 7.09583 9.47917 7.2875 9.2875C7.47917 9.09583 7.71667 9 8 9C8.28333 9 8.52083 9.09583 8.7125 9.2875C8.90417 9.47917 9 9.71667 9 10V14C9 14.2833 8.90417 14.5208 8.7125 14.7125C8.52083 14.9042 8.28333 15 8 15ZM12 13C11.7167 13 11.4792 12.9042 11.2875 12.7125C11.0958 12.5208 11 12.2833 11 12C11 11.7167 11.0958 11.4792 11.2875 11.2875C11.4792 11.0958 11.7167 11 12 11H20C20.2833 11 20.5208 11.0958 20.7125 11.2875C20.9042 11.4792 21 11.7167 21 12C21 12.2833 20.9042 12.5208 20.7125 12.7125C20.5208 12.9042 20.2833 13 20 13H12ZM16 9C15.7167 9 15.4792 8.90417 15.2875 8.7125C15.0958 8.52083 15 8.28333 15 8V4C15 3.71667 15.0958 3.47917 15.2875 3.2875C15.4792 3.09583 15.7167 3 16 3C16.2833 3 16.5208 3.09583 16.7125 3.2875C16.9042 3.47917 17 3.71667 17 4V5H20C20.2833 5 20.5208 5.09583 20.7125 5.2875C20.9042 5.47917 21 5.71667 21 6C21 6.28333 20.9042 6.52083 20.7125 6.7125C20.5208 6.90417 20.2833 7 20 7H17V8C17 8.28333 16.9042 8.52083 16.7125 8.7125C16.5208 8.90417 16.2833 9 16 9ZM4 7C3.71667 7 3.47917 6.90417 3.2875 6.7125C3.09583 6.52083 3 6.28333 3 6C3 5.71667 3.09583 5.47917 3.2875 5.2875C3.47917 5.09583 3.71667 5 4 5H12C12.2833 5 12.5208 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6C13 6.28333 12.9042 6.52083 12.7125 6.7125C12.5208 6.90417 12.2833 7 12 7H4Z", fill: "#161616" })));

const NewCloseIcon = () => (index.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32", fill: "none" },
  index.h("g", { "clip-path": "url(#clip0_1696_811)" },
    index.h("path", { d: "M24 9.4L22.6 8L16 14.6L9.4 8L8 9.4L14.6 16L8 22.6L9.4 24L16 17.4L22.6 24L24 22.6L17.4 16L24 9.4Z", fill: "#C6C6C6" })),
  index.h("defs", null,
    index.h("clipPath", { id: "clip0_1696_811" },
      index.h("rect", { width: "32", height: "32", fill: "white" })))));

const FavoriteIcon = () => (index.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
  index.h("path", { d: "M12 21.325C11.7667 21.325 11.5292 21.2834 11.2875 21.2C11.0458 21.1167 10.8333 20.9834 10.65 20.8L8.925 19.225C7.15833 17.6084 5.5625 16.0042 4.1375 14.4125C2.7125 12.8209 2 11.0667 2 9.15002C2 7.58336 2.525 6.27502 3.575 5.22502C4.625 4.17502 5.93333 3.65002 7.5 3.65002C8.38333 3.65002 9.21667 3.83752 10 4.21252C10.7833 4.58752 11.45 5.10002 12 5.75002C12.55 5.10002 13.2167 4.58752 14 4.21252C14.7833 3.83752 15.6167 3.65002 16.5 3.65002C18.0667 3.65002 19.375 4.17502 20.425 5.22502C21.475 6.27502 22 7.58336 22 9.15002C22 11.0667 21.2917 12.825 19.875 14.425C18.4583 16.025 16.85 17.6334 15.05 19.25L13.35 20.8C13.1667 20.9834 12.9542 21.1167 12.7125 21.2C12.4708 21.2834 12.2333 21.325 12 21.325ZM11.05 7.75002C10.5667 7.06669 10.05 6.54586 9.5 6.18752C8.95 5.82919 8.28333 5.65002 7.5 5.65002C6.5 5.65002 5.66667 5.98336 5 6.65002C4.33333 7.31669 4 8.15002 4 9.15002C4 10.0167 4.30833 10.9375 4.925 11.9125C5.54167 12.8875 6.27917 13.8334 7.1375 14.75C7.99583 15.6667 8.87917 16.525 9.7875 17.325C10.6958 18.125 11.4333 18.7834 12 19.3C12.5667 18.7834 13.3042 18.125 14.2125 17.325C15.1208 16.525 16.0042 15.6667 16.8625 14.75C17.7208 13.8334 18.4583 12.8875 19.075 11.9125C19.6917 10.9375 20 10.0167 20 9.15002C20 8.15002 19.6667 7.31669 19 6.65002C18.3333 5.98336 17.5 5.65002 16.5 5.65002C15.7167 5.65002 15.05 5.82919 14.5 6.18752C13.95 6.54586 13.4333 7.06669 12.95 7.75002C12.8333 7.91669 12.6917 8.04169 12.525 8.12502C12.3583 8.20836 12.1833 8.25002 12 8.25002C11.8167 8.25002 11.6417 8.20836 11.475 8.12502C11.3083 8.04169 11.1667 7.91669 11.05 7.75002Z", fill: "white" })));

const FavoriteIconPressed = () => (index.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
  index.h("path", { d: "M12 21.325C11.7667 21.325 11.5292 21.2834 11.2875 21.2C11.0458 21.1167 10.8333 20.9834 10.65 20.8L8.925 19.225C7.15833 17.6084 5.5625 16.0042 4.1375 14.4125C2.7125 12.8209 2 11.0667 2 9.15002C2 7.58336 2.525 6.27502 3.575 5.22502C4.625 4.17502 5.93333 3.65002 7.5 3.65002C8.38333 3.65002 9.21667 3.83752 10 4.21252C10.7833 4.58752 11.45 5.10002 12 5.75002C12.55 5.10002 13.2167 4.58752 14 4.21252C14.7833 3.83752 15.6167 3.65002 16.5 3.65002C18.0667 3.65002 19.375 4.17502 20.425 5.22502C21.475 6.27502 22 7.58336 22 9.15002C22 11.0667 21.2917 12.825 19.875 14.425C18.4583 16.025 16.85 17.6334 15.05 19.25L13.35 20.8C13.1667 20.9834 12.9542 21.1167 12.7125 21.2C12.4708 21.2834 12.2333 21.325 12 21.325Z", fill: "white" })));

const COLUMNS_NUMBER_CSS_VAR = "--vviinn-carousel-columns-internal";
const CAROUSEL_WIDTH_CSS_VAR = "--vviinn-carousel-content-width";
const CAROUSEL_IMAGE_WIDTH_CSS_VAR = "--vviinn-carousel-image-width";
const SET_MODE_IMAGE_WIDTH = "--vviinn-set-mode-image-width";
const CONTENT_GROUP_CSS_CLASS = "items-group";

const numberUnderDivisionSemigroup = {
  concat: (x, y) => x / y,
};
Object.assign(Object.assign({}, numberUnderDivisionSemigroup), { empty: 1 });
const calculateDiscount = (price, discount) => {
  return Math.round(price * (1 - discount / 100) * 100) / 100;
};
const generateRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

/**
 * The `Apply` class provides the `ap` which is used to apply a function to an argument under a type constructor.
 *
 * `Apply` can be used to lift functions of two or more arguments to work on values wrapped with the type constructor
 * `f`.
 *
 * Instances must satisfy the following law in addition to the `Functor` laws:
 *
 * 1. Associative composition: `F.ap(F.ap(F.map(fbc, bc => ab => a => bc(ab(a))), fab), fa) <-> F.ap(fbc, F.ap(fab, fa))`
 *
 * Formally, `Apply` represents a strong lax semi-monoidal endofunctor.
 *
 * @example
 * import * as O from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (a: string) => (b: number) => (c: boolean) => a + String(b) + String(c)
 * const fa: O.Option<string> = O.some('s')
 * const fb: O.Option<number> = O.some(1)
 * const fc: O.Option<boolean> = O.some(true)
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     // lift a function
 *     O.some(f),
 *     // apply the first argument
 *     O.ap(fa),
 *     // apply the second argument
 *     O.ap(fb),
 *     // apply the third argument
 *     O.ap(fc)
 *   ),
 *   O.some('s1true')
 * )
 *
 * @since 2.0.0
 */
function curried(f, n, acc) {
    return function (x) {
        var combined = Array(acc.length + 1);
        for (var i = 0; i < acc.length; i++) {
            combined[i] = acc[i];
        }
        combined[acc.length] = x;
        return n === 0 ? f.apply(null, combined) : curried(f, n - 1, combined);
    };
}
var tupleConstructors = {
    1: function (a) { return [a]; },
    2: function (a) { return function (b) { return [a, b]; }; },
    3: function (a) { return function (b) { return function (c) { return [a, b, c]; }; }; },
    4: function (a) { return function (b) { return function (c) { return function (d) { return [a, b, c, d]; }; }; }; },
    5: function (a) { return function (b) { return function (c) { return function (d) { return function (e) { return [a, b, c, d, e]; }; }; }; }; }
};
function getTupleConstructor(len) {
    if (!search_store.has.call(tupleConstructors, len)) {
        tupleConstructors[len] = curried(search_store.tuple, len - 1, []);
    }
    return tupleConstructors[len];
}
function sequenceT(F) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var len = args.length;
        var f = getTupleConstructor(len);
        var fas = F.map(args[0], f);
        for (var i = 1; i < len; i++) {
            fas = F.ap(fas, args[i]);
        }
        return fas;
    };
}

const vviinnCarouselCss = ":host{--vviinn-carousel-columns-internal:var(--vviinn-carousel-columns, 4)}.body{display:flex;position:relative;width:var(--vviinn-carousel-content-width);flex-direction:column}.bullets{display:flex;flex-direction:row;grid-gap:24px;justify-content:center}.bullet{width:10px;height:10px;background:#e0e0e0;border-radius:50%;cursor:pointer}.bullet.active{background:#161616}.content:not(.show-scrollbar),.content.grid{scrollbar-color:#fff0 #fff0}.content:not(.show-scrollbar)::-webkit-scrollbar,.content.grid::-webkit-scrollbar{opacity:0}.content{display:flex;flex-direction:row;gap:8px;overflow-y:hidden;overflow-x:auto;flex-grow:1;padding-bottom:16px}.content.left>*{scroll-snap-align:start}.content.right>*{scroll-snap-align:end}:host(.continuity) .prev,:host(.continuity) .next{border-radius:2px}:host(.grid) .prev,:host(.grid) .next{border-radius:50%}.prev,.next{align-items:center;background-color:white;border:none;box-shadow:0px 2px 6px rgba(0, 0, 0, 0.15);fill:#525252;cursor:pointer;display:grid;height:40px;justify-items:center;position:absolute;top:calc(50% - 20px);width:40px;z-index:1;padding:0;margin:0}.next:disabled,.prev:disabled{display:none}.prev svg{transform:rotate(180deg);margin-left:-5px}.prev{left:0}.next{right:0}.items-group{display:grid;grid-gap:16px;grid-template-columns:repeat(var(--vviinn-carousel-columns-internal), 1fr);min-width:100%}@media (max-width: 480px){.items-group{grid-template-columns:repeat(2, 1fr)}}.body.set{max-width:100%;justify-content:space-between;margin-left:auto;display:flex;flex-direction:row;gap:112px}.body.set::-webkit-scrollbar{display:none}@media (max-width: 768px){.body.set{gap:40px}}.content.set{grid-gap:20px;height:-moz-fit-content;height:fit-content;max-width:-moz-fit-content;max-width:fit-content;overflow:unset}";

const VviinnCarousel = class {
  constructor(hostRef) {
    index.registerInstance(this, hostRef);
    this.vviinnProductLoad = index.createEvent(this, "vviinnProductLoad", 7);
    this.vviinnProductView = index.createEvent(this, "vviinnProductView", 7);
    this.columns = 0;
    this.resizeObserver = new ResizeObserver(() => this.handleResize());
    this.defaultAnimationInterval = 2000;
    this.setModeMaxDiscount = null;
    this.mutationObserver = new MutationObserver(() => this.cloneSlottedContent());
    this.handleWindowResize = () => this.setImageWidthSetMode("100%");
    this.isLastGroup = () => this.isGridMode &&
      this.activeContentGroup === this.getContentGroups().length - 1;
    this.isFirstGroup = () => this.isGridMode && this.activeContentGroup === 0;
    this.updateCard = (productId, step, animationInterval) => {
      let clickedProduct = this.crossSellingRecommendations.find((item) => item.productId === productId);
      const crossSellingIndex = this.crossSellingRecommendations.indexOf(clickedProduct);
      const recommendationIndex = this.recommendations.indexOf(clickedProduct);
      const newCrossSellingRecommendations = this.crossSellingRecommendations;
      if (recommendationIndex + step < this.recommendations.length) {
        const newRecommendation = this.recommendations[recommendationIndex + step];
        newCrossSellingRecommendations[crossSellingIndex] = newRecommendation;
        const productData = this.getProductData(newRecommendation, recommendationIndex + step);
        this.vviinnProductLoad.emit(productData);
        this.crossSellingRecommendations = [...newCrossSellingRecommendations];
        let element = this.el.querySelector(`[data-id="${productId}"]`);
        const button = element.shadowRoot.querySelector(".update-button");
        button === null || button === void 0 ? void 0 : button.classList.add("hidden");
        const imageWidth = element.getBoundingClientRect().width;
        this.setImageWidthSetMode(`${imageWidth}px`);
        const animationTimer = setTimeout(() => {
          if (recommendationIndex + step * 2 <= this.recommendations.length - 1) {
            button === null || button === void 0 ? void 0 : button.classList.remove("hidden");
          }
          this.vviinnProductView.emit(productData);
          clearTimeout(animationTimer);
        }, animationInterval);
      }
    };
    this.moveDirection = "right";
    this.contentGroups = [];
    this.activeContentGroup = 0;
    this.isRTL = false;
    this.crossSellingRecommendations = [];
    this.setModeDiscount = null;
    this.currentDiscountIndex = 0;
    this.setModeAppliedDiscounts = {};
    this.mode = "continuity";
    this.imageWidth = 140;
    this.showScroll = true;
    this.campaignTypeId = undefined;
    this.widgetElementId = undefined;
    this.gridArrowsDynamic = undefined;
    this.recommendations = [];
    this.widgetVersion = undefined;
    this.addToBasketShow = undefined;
    this.updatingAllCards = undefined;
    this.updateButtonLocation = undefined;
    this.replaceSlotsContent = undefined;
    this.setModeDiscountsArray = undefined;
    this.imageRatio = undefined;
    this.addPriceContainer = false;
    this.favoriteShow = undefined;
    this.currencySign = undefined;
    this.pricePrefix = "";
    this.locale = undefined;
  }
  getProductData(recommendation, productRank) {
    return {
      productId: recommendation.productId,
      productRank,
      productName: recommendation.productTitle,
      productType: recommendation.productType,
      widgetType: "VPR",
      campaignTypeId: this.campaignTypeId,
      campaignTypeName: _package.campaignTypeNames[this.campaignTypeId],
      widgetId: this.widgetElementId,
      widgetVersion: this.widgetVersion,
    };
  }
  componentWillLoad() {
    this.isRTL = document.dir === "rtl";
  }
  connectedCallback() {
    this.setItemWidth();
    this.isSetMode = this.mode === "set";
    this.isGridMode = this.mode === "grid";
    this.isContinuityMode = this.mode === "continuity";
    const columnsNumber = this.getColumnsNumber();
    if (this.isSetMode) {
      window.addEventListener("resize", this.handleWindowResize);
      this.sourceProduct = search_store.searchState.sourceProduct;
      this.setModeDiscount = this.setModeDiscountsArray[0];
      this.setModeMaxDiscount =
        this.setModeDiscountsArray[this.setModeDiscountsArray.length - 1];
    }
    if (this.isSetMode && this.recommendations.length >= columnsNumber) {
      this.crossSellingRecommendations = this.recommendations.slice(0, columnsNumber);
    }
  }
  disconnectedCallback() {
    this.resizeObserver.disconnect();
    window.removeEventListener("resize", this.handleWindowResize);
  }
  componentDidUpdate() {
    this.replaceSlotsContent();
  }
  componentDidLoad() {
    this.setWidth();
    this.columns = this.getColumnsNumber();
    const slot = this.el.querySelector(".content");
    this.mutationObserver.observe(slot, { subtree: true, childList: true });
    this.resizeObserver.observe(this.getHostParent());
    if (this.isGridMode) {
      const contentNode = this.getContentNode();
      contentNode.addEventListener("scrollend", () => {
        this.activeContentGroup = this.getActiveGroupIndex();
      });
    }
  }
  updatingAllCardsWatcher() {
    if (!this.updatingAllCards)
      return;
    const step = this.getColumnsNumber();
    this.crossSellingRecommendations.forEach((item) => {
      this.updateCard(item.productId, step, this.defaultAnimationInterval);
    });
  }
  crossSellingClickListener({ detail }) {
    const step = this.getColumnsNumber();
    const { animationInterval, productData } = detail;
    this.updateCard(productData.productId, step, animationInterval);
  }
  getItemWidthFromDocument() {
    return parseInt(getComputedStyle(document.body).getPropertyValue(CAROUSEL_IMAGE_WIDTH_CSS_VAR));
  }
  async trackAddToBasket({ detail }) {
    if (!this.isSetMode)
      return;
    const { productId } = detail;
    if (this.setModeAppliedDiscounts.hasOwnProperty(productId))
      return;
    this.setModeAppliedDiscounts = Object.assign(Object.assign({}, this.setModeAppliedDiscounts), { [productId]: this.setModeDiscount });
    const isMaxDiscount = this.setModeDiscount === this.setModeMaxDiscount;
    if (!isMaxDiscount) {
      this.currentDiscountIndex += 1;
      this.setModeDiscount =
        this.setModeDiscountsArray[this.currentDiscountIndex];
    }
  }
  setItemWidth() {
    const widthInDocument = this.getItemWidthFromDocument();
    const itemWidth = isNaN(widthInDocument)
      ? this.imageWidth
      : widthInDocument;
    this.el.style.setProperty(CAROUSEL_IMAGE_WIDTH_CSS_VAR, `${itemWidth}px`);
  }
  setImageWidthSetMode(width) {
    this.el.style.setProperty(SET_MODE_IMAGE_WIDTH, width);
  }
  getContentClassMap() {
    return {
      content: true,
      [this.moveDirection]: true,
      [this.mode]: true,
      "show-scrollbar": this.isSetMode ? false : this.showScroll,
    };
  }
  handleResize() {
    this.setWidth();
    this.setItemWidth();
    const newColumns = this.getColumnsNumber();
    if (newColumns !== this.columns) {
      this.columns = newColumns;
    }
  }
  calculateMoveStep() {
    const contentWidths = this.getContent().map((el) => el.getBoundingClientRect().width);
    const sum = contentWidths.reduce((acc, val) => acc + val, 0);
    const contentGap = search_store._function.pipe(window.getComputedStyle(this.getContentNode()), (computedStyle) => computedStyle.getPropertyValue("gap"), (contentGapString) => parseInt(contentGapString.split("px")[0]), (contentGap) => (isNaN(contentGap) ? 0 : contentGap));
    return sum / contentWidths.length + contentGap;
  }
  getHostParent() {
    const parent = this.el.parentNode;
    return parent.host.parentElement;
  }
  setWidth() {
    const parent = this.getHostParent();
    if (!parent)
      return;
    const parentStyles = getComputedStyle(parent);
    const parentWidth = parent.getBoundingClientRect().width;
    const width = parentWidth -
      (parseInt(parentStyles["padding-right"]) +
        parseInt(parentStyles["padding-left"]));
    this.el.style.setProperty(CAROUSEL_WIDTH_CSS_VAR, `${width}px`);
  }
  getParent() {
    const parentNode = this.el.parentNode;
    const host = parentNode.host;
    return host.parentElement;
  }
  cloneSlottedContent() {
    this.setWidth();
  }
  getActiveGroupIndex() {
    const groups = this.getContentGroups();
    const groupsPositions = groups.map((g) => g.getBoundingClientRect().left);
    const indexedPositions = groupsPositions
      .map((value, index) => [value, index])
      .filter((x) => x[0] >= 0);
    return indexedPositions.length > 0
      ? this.isRTL
        ? indexedPositions[indexedPositions.length - 1][1]
        : indexedPositions[0][1]
      : 0;
  }
  getContentNode() {
    return this.el.querySelector(".content");
  }
  getContent() {
    const children = this.getContentNode().children;
    return Array.from(children).map((c) => c);
  }
  getColumnsNumber() {
    const styleSheet = getComputedStyle(this.el);
    const columnsInCss = styleSheet.getPropertyValue(COLUMNS_NUMBER_CSS_VAR);
    const columnsNumber = parseInt(columnsInCss);
    return columnsNumber && !isNaN(columnsNumber) ? columnsNumber : 4;
  }
  getContentGroups() {
    return Array.from(this.el.querySelectorAll(`.${CONTENT_GROUP_CSS_CLASS}`));
  }
  handleCarouselButtonClick(action) {
    this.moveDirection = action;
    const contentContainer = this.getContentNode();
    const { scrollLeft } = contentContainer;
    const step = this.calculateMoveStep();
    requestAnimationFrame(() => {
      contentContainer.scrollTo({
        top: 0,
        left: action === "right" ? scrollLeft + step : scrollLeft - step,
        behavior: "smooth",
      });
    });
  }
  scroll(index) {
    const contentContainer = this.getContentNode();
    requestAnimationFrame(() => {
      contentContainer.scrollTo({
        top: 0,
        left: this.calculateMoveStep() * index,
        behavior: "smooth",
      });
    });
  }
  showBullets() {
    return this.isGridMode && this.showScroll;
  }
  showScrollbar() {
    return this.isContinuityMode && this.showScroll;
  }
  getClassMap() {
    return {
      [this.mode]: true,
      "show-scrollbar": this.showScrollbar(),
    };
  }
  renderRecommendation(recommendation, rank) {
    var _a, _b, _c;
    const appliedDiscount = this.setModeAppliedDiscounts[recommendation.productId];
    const setModeDiscount = calculateDiscount((_a = recommendation.price) === null || _a === void 0 ? void 0 : _a.actual, appliedDiscount !== null && appliedDiscount !== void 0 ? appliedDiscount : this.setModeDiscount);
    const salePrice = this.isSetMode
      ? setModeDiscount
      : recommendation.price.sale;
    return (index.h("vviinn-product-card", { index: rank, part: "product-part", productId: recommendation.productId, productTitle: recommendation.title, productType: recommendation.productType, deeplink: recommendation.deeplink, image: recommendation.image.thumbnail, brand: recommendation.brand, imageWidth: this.imageWidth, imageRatio: this.imageRatio, price: recommendation.price.actual, salePrice: salePrice, basePrice: (_b = recommendation.basePrice) === null || _b === void 0 ? void 0 : _b.actual, baseSalePrice: (_c = recommendation.basePrice) === null || _c === void 0 ? void 0 : _c.sale, responsive: this.isGridMode, campaignTypeId: this.campaignTypeId, widgetElementId: this.widgetElementId, widgetVersion: this.widgetVersion, addToBasketShow: this.addToBasketShow, "data-id": recommendation.productId, energyCertifications: recommendation.energyCertifications, updatingAllCards: this.updatingAllCards, defaultAnimationInterval: this.defaultAnimationInterval, updateButtonLocation: this.updateButtonLocation, appliedDiscountPercentage: appliedDiscount, currentDiscountPercentage: this.setModeDiscount, currency: this.currencySign, pricePrefix: this.pricePrefix, locale: this.locale, setMode: this.isSetMode, customLabels: index$1.getCustomLabels(recommendation), addPriceContainer: this.addPriceContainer, favoriteShow: this.favoriteShow }));
  }
  renderRecommendationGroup(elements) {
    return (index.h("div", { class: CONTENT_GROUP_CSS_CLASS, part: "items-group" }, ...elements));
  }
  renderRecommendationGroups(elements) {
    return elements.map((el) => this.renderRecommendationGroup(el));
  }
  renderRecommendations() {
    return this.isGridMode
      ? this.renderGrid()
      : this.renderRecommendationsElements();
  }
  renderRecommendationsElements() {
    const recommendations = this.isSetMode
      ? this.crossSellingRecommendations
      : this.recommendations;
    return recommendations.map((r, i) => this.renderRecommendation(r, i));
  }
  renderGrid() {
    const recommendations = this.renderRecommendationsElements();
    const grouppedContent = search_store._Array.chunksOf(this.getColumnsNumber())(recommendations);
    return this.renderRecommendationGroups(grouppedContent);
  }
  renderBullets() {
    const numberOfBullets = Math.ceil(this.recommendations.length / this.getColumnsNumber());
    const bulletsArray = Array.from(Array(numberOfBullets).keys());
    return bulletsArray.map((index$1) => (index.h("div", { class: {
        bullet: true,
        active: this.activeContentGroup === index$1,
      }, onClick: () => this.scroll(index$1) })));
  }
  render() {
    var _a, _b;
    return (index.h(index.Host, { class: this.getClassMap() }, index.h("div", { class: Object.assign({ body: true }, this.getClassMap()) }, !this.isSetMode && (index.h("button", { class: "prev", onClick: () => this.handleCarouselButtonClick("left"), part: "carousel-button", disabled: this.gridArrowsDynamic && this.isFirstGroup() }, index.h(ChevronIcon, null))), this.isSetMode && this.crossSellingRecommendations.length > 0 && (index.h("vviinn-product-card", { part: "product-part", class: "set-mode product-card--source", productTitle: this.sourceProduct.title, image: this.sourceProduct.image.thumbnail, price: this.sourceProduct.price.actual, salePrice: this.sourceProduct.price.sale, basePrice: (_a = this.sourceProduct.basePrice) === null || _a === void 0 ? void 0 : _a.actual, baseSalePrice: (_b = this.sourceProduct.basePrice) === null || _b === void 0 ? void 0 : _b.sale, addPriceContainer: this.addPriceContainer, imageRatio: 1, imageWidth: 300, isSourceProduct: true, currency: this.currencySign, pricePrefix: this.pricePrefix, setMode: this.isSetMode, locale: this.locale, favoriteShow: this.favoriteShow })), index.h("div", { class: this.getContentClassMap() }, this.renderRecommendations()), !this.isSetMode && (index.h("button", { class: "next", onClick: () => this.handleCarouselButtonClick("right"), part: "carousel-button", disabled: this.gridArrowsDynamic && this.isLastGroup() }, index.h(ChevronIcon, null)))), this.showBullets() && (index.h("div", { class: "bullets" }, this.renderBullets()))));
  }
  get el() { return index.getElement(this); }
  static get watchers() { return {
    "updatingAllCards": ["updatingAllCardsWatcher"]
  }; }
};
VviinnCarousel.style = vviinnCarouselCss;

const vviinnEnergyLabelCss = ":host{--font-family-base:Inter, system-ui, sans-serif;--font-family-mono:monospace;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;--font-size-title:24px;--font-size-headline:18px;--font-size-label-large:16px;--font-size-label:14px;--font-size-body-large:16px;--font-size-body:14px;--font-size-caption:12px;--line-height-title:32px;--line-height-headline:24px;--line-height-label-large:24px;--line-height-label:20px;--line-height-body-large:24px;--line-height-body:20px;--line-height-caption:16px;--letter-spacing-title:0px;--letter-spacing-headline:0px;--letter-spacing-label-large:0px;--letter-spacing-label:0px;--letter-spacing-body-large:0px;--letter-spacing-body:0px;--letter-spacing-caption:0px;--font-weight-400:400;--font-weight-500:500;--font-weight-600:600;--font-weight-700:700;--spacing-none:0px;--spacing-25:2px;--spacing-50:4px;--spacing-75:6px;--spacing-100:8px;--spacing-125:10px;--spacing-150:12px;--spacing-200:16px;--spacing-250:20px;--spacing-300:24px;--spacing-400:32px;--spacing-500:40px;--spacing-600:48px;--border-radius-none:0px;--border-radius-25:2px;--border-radius-50:4px;--border-radius-100:8px;--border-radius-150:12px;--border-radius-200:16px;--border-radius-300:24px;--border-radius-400:32px;--border-radius-full:9999px;--stroke-width-none:0px;--stroke-width-25:1px;--stroke-width-50:2px;--stroke-width-75:3px;--stroke-width-100:4px;--stroke-width-150:6px;--stroke-width-200:8px;--stroke-width-300:12px;--product-card-widget-min-width:135px;--product-card-results-min-width:250px;--image-set-mode-min-size:155px;--product-card-set-mode-max-width:300px;--source-card-set-mode-max-width:500px;--filter-blur-none:0px;--filter-blur-100:8px;--filter-blur-150:12px;--filter-blur-200:16px;--color-bg-base:#ffffff;--color-bg-inverse:#161616;--color-border-00:#ffffff;--color-border-01:#f4f4f4;--color-border-02:#e0e0e0;--color-border-03:#c6c6c6;--color-border-inverse-00:#161616;--color-border-inverse-01:#393939;--color-field-01:#ffffff;--color-field-02:#f4f4f4;--color-icon-primary:#161616;--color-icon-secondary:#525252;--color-icon-helper:#8d8d8d;--color-icon-on-color:#ffffff;--color-icon-inverse:#ffffff;--color-icon-disabled:#16161640;--color-text-primary:#161616;--color-text-secondary:#525252;--color-text-helper:#8d8d8d;--color-text-placeholder:#a8a8a8;--color-text-on-color:#ffffff;--color-text-inverse:#ffffff;--color-text-disabled:#16161640;--button-bg-color-primary:#000000;--button-bg-color-primary-hover:#161616;--button-bg-color-primary-active:#1e1e1e;--button-bg-color-secondary:#f4f4f4;--button-bg-color-secondary-hover:#e0e0e0;--button-bg-color-secondary-active:#c6c6c6;--button-bg-color-ghost-hover:#f4f4f4;--button-bg-color-ghost-active:#eaeaea;--button-bg-color-frosted:#6f6f6f66;--button-bg-color-frosted-hover:#6f6f6f80;--button-bg-color-frosted-active:#6f6f6f99;--button-bg-color-disabled:#e0e0e0;--button-bg-color-positive:#dcfce7;--surface-bg-color-01:#f4f4f4;--surface-bg-color-01-hover:#eaeaea;--surface-bg-color-01-active:#e0e0e0;--surface-bg-color-02:#ffffff;--surface-bg-color-inverse:#262626;--surface-bg-color-inverse-hover:#303030;--surface-bg-color-inverse-active:#393939;--surface-bg-color-disabled:#e0e0e0;--chip-bg-color-primary:#161616;--chip-bg-color-primary-hover:#1e1e1e;--chip-bg-color-primary-active:#262626;--chip-bg-color-subtle:#f4f4f4;--chip-bg-color-subtle-hover:#eaeaea;--chip-bg-color-subtle-active:#e0e0e0;--chip-bg-color-outline-hover:#f4f4f4;--chip-bg-color-outline-active:#eaeaea;--label-bg-color-accent:#ff3944;}:host{display:contents;line-height:0px}:host(.hidden){display:none}.container{display:flex;flex-direction:row;max-width:100%;gap:var(--spacing-75);justify-content:var(\n    --product-card-content-align,\n    var(--product-card-content-align-default)\n  );align-items:center}.info-container{width:-moz-fit-content;width:fit-content;height:100%;display:flex;justify-content:center;text-align:left;flex-direction:column;font-size:var(--font-size-caption);font-weight:var(--font-weight-400);line-height:var(--line-height-caption);letter-spacing:var(--letter-spacing-caption);font-style:normal}.class-label-icon{display:inline-block;height:32px;width:auto;flex-shrink:0}.product-type,.data-sheet-link{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;overflow-wrap:anywhere;overflow:hidden;text-overflow:ellipsis;text-decoration:none;color:var(--color-text-primary)}.product-type{color:var(--color-text-helper)}.data-sheet-link{display:none;cursor:pointer;text-decoration:none;color:var(--color-text-primary)}";

const VviinnEnergyLabel = class {
  constructor(hostRef) {
    index.registerInstance(this, hostRef);
    this.classIconUrls = undefined;
    this.productType = undefined;
    this.classDataSheetUrl = undefined;
    this.iconDirection = "right";
  }
  componentWillLoad() {
    _package.slotChangeListener(this, this.el);
  }
  render() {
    return (index.h(index.Host, { class: {
        hidden: !this.classIconUrls && !this.productType && !this.classDataSheetUrl,
      }, exportparts: "energy-label-container, energy-label-icon, energy-label-product-type, energy-label-data-sheet-link" }, index.h("div", { class: "container", part: "energy-label-container" }, !!this.classIconUrls && (index.h("img", { class: "class-label-icon", part: "energy-label-icon", src: this.classIconUrls[this.iconDirection] })), (this.productType || this.classDataSheetUrl) && (index.h("div", { class: "info-container" }, this.productType && (index.h("span", { class: "product-type", part: "energy-label-product-type" }, this.productType)), this.classDataSheetUrl && (index.h("a", { class: "data-sheet-link", part: "energy-label-data-sheet-link", href: this.classDataSheetUrl, target: "_blank", rel: "noopener noreferrer" }, index.h("slot", { name: "vviinn-energy-label-data-sheet-text" }, index$2.instance.t("energyLabel.dataSheetText")))))))));
  }
  get el() { return index.getElement(this); }
};
VviinnEnergyLabel.style = vviinnEnergyLabelCss;

const getFilterOptions = (filter) => {
  return filter && "values" in filter
    ? filter.values
    : filter && "histogram" in filter
      ? filter.histogram
      : [];
};

const vviinnFiltersCss$1 = ":host{--font-family-base:Inter, system-ui, sans-serif;--font-family-mono:monospace;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;--font-size-title:24px;--font-size-headline:18px;--font-size-label-large:16px;--font-size-label:14px;--font-size-body-large:16px;--font-size-body:14px;--font-size-caption:12px;--line-height-title:32px;--line-height-headline:24px;--line-height-label-large:24px;--line-height-label:20px;--line-height-body-large:24px;--line-height-body:20px;--line-height-caption:16px;--letter-spacing-title:0px;--letter-spacing-headline:0px;--letter-spacing-label-large:0px;--letter-spacing-label:0px;--letter-spacing-body-large:0px;--letter-spacing-body:0px;--letter-spacing-caption:0px;--font-weight-400:400;--font-weight-500:500;--font-weight-600:600;--font-weight-700:700;--spacing-none:0px;--spacing-25:2px;--spacing-50:4px;--spacing-75:6px;--spacing-100:8px;--spacing-125:10px;--spacing-150:12px;--spacing-200:16px;--spacing-250:20px;--spacing-300:24px;--spacing-400:32px;--spacing-500:40px;--spacing-600:48px;--border-radius-none:0px;--border-radius-25:2px;--border-radius-50:4px;--border-radius-100:8px;--border-radius-150:12px;--border-radius-200:16px;--border-radius-300:24px;--border-radius-400:32px;--border-radius-full:9999px;--stroke-width-none:0px;--stroke-width-25:1px;--stroke-width-50:2px;--stroke-width-75:3px;--stroke-width-100:4px;--stroke-width-150:6px;--stroke-width-200:8px;--stroke-width-300:12px;--product-card-widget-min-width:135px;--product-card-results-min-width:250px;--image-set-mode-min-size:155px;--product-card-set-mode-max-width:300px;--source-card-set-mode-max-width:500px;--filter-blur-none:0px;--filter-blur-100:8px;--filter-blur-150:12px;--filter-blur-200:16px;--color-bg-base:#ffffff;--color-bg-inverse:#161616;--color-border-00:#ffffff;--color-border-01:#f4f4f4;--color-border-02:#e0e0e0;--color-border-03:#c6c6c6;--color-border-inverse-00:#161616;--color-border-inverse-01:#393939;--color-field-01:#ffffff;--color-field-02:#f4f4f4;--color-icon-primary:#161616;--color-icon-secondary:#525252;--color-icon-helper:#8d8d8d;--color-icon-on-color:#ffffff;--color-icon-inverse:#ffffff;--color-icon-disabled:#16161640;--color-text-primary:#161616;--color-text-secondary:#525252;--color-text-helper:#8d8d8d;--color-text-placeholder:#a8a8a8;--color-text-on-color:#ffffff;--color-text-inverse:#ffffff;--color-text-disabled:#16161640;--button-bg-color-primary:#000000;--button-bg-color-primary-hover:#161616;--button-bg-color-primary-active:#1e1e1e;--button-bg-color-secondary:#f4f4f4;--button-bg-color-secondary-hover:#e0e0e0;--button-bg-color-secondary-active:#c6c6c6;--button-bg-color-ghost-hover:#f4f4f4;--button-bg-color-ghost-active:#eaeaea;--button-bg-color-frosted:#6f6f6f66;--button-bg-color-frosted-hover:#6f6f6f80;--button-bg-color-frosted-active:#6f6f6f99;--button-bg-color-disabled:#e0e0e0;--button-bg-color-positive:#dcfce7;--surface-bg-color-01:#f4f4f4;--surface-bg-color-01-hover:#eaeaea;--surface-bg-color-01-active:#e0e0e0;--surface-bg-color-02:#ffffff;--surface-bg-color-inverse:#262626;--surface-bg-color-inverse-hover:#303030;--surface-bg-color-inverse-active:#393939;--surface-bg-color-disabled:#e0e0e0;--chip-bg-color-primary:#161616;--chip-bg-color-primary-hover:#1e1e1e;--chip-bg-color-primary-active:#262626;--chip-bg-color-subtle:#f4f4f4;--chip-bg-color-subtle-hover:#eaeaea;--chip-bg-color-subtle-active:#e0e0e0;--chip-bg-color-outline-hover:#f4f4f4;--chip-bg-color-outline-active:#eaeaea;--label-bg-color-accent:#ff3944;}:host{display:block;font-family:var(--font-family, var(--font-family-base));font-style:normal;}:host(.show-in-widget){padding-left:24px}.filters-modal-list,.sub-filters-wrapper,.main-filters-list,.filters-modal-sub-list,.selected-filters-wrapper{list-style:none;margin:0;padding:0}.main-filters-list{padding:var(--spacing-25);gap:var(--spacing-25);border-radius:8px;background:var(--surface-bg-color-01);display:inline-flex}vviinn-price-range{max-width:400px}:host(.show-in-widget) vviinn-price-range{max-width:unset}.filters-modal-main-button,.filters-sub-button,.filters-main-button,.filters-modal-close,.filters-sub-button-selected{font-family:var(--font-family, var(--font-family-base));cursor:pointer;border:none}.filters-sub-button,.filters-main-button{font-size:var(--font-size-body);font-weight:var(--font-weight-400);line-height:var(--line-height-body);letter-spacing:var(--letter-spacing-body);display:flex;justify-content:center;align-items:center;border-radius:6px}.filters-main-button{padding:var(--spacing-100);color:var(--color-text-helper);background:none}.filters-main-button.active,.filters-main-button:hover{background:var(--surface-bg-color-02);color:var(--color-text-primary)}.sub-filters-wrapper,.selected-filters-wrapper{gap:var(--spacing-100);display:flex;flex-direction:row;overflow-x:auto;scrollbar-width:thin;padding-bottom:6px}.sub-filters-wrapper{align-items:center;gap:var(--spacing-100);margin-top:16px;margin:16px -2px 0}.sub-filters-wrapper>li{padding:2px}.selected-filters-wrapper{margin-top:var(--spacing-125);gap:var(--spacing-100);flex-wrap:wrap}:host(.show-in-widget) .selected-filters-wrapper{flex-wrap:unset;overflow-x:auto}:host(.show-in-widget) .sub-filters-wrapper,:host(.show-in-widget) .selected-filters-wrapper{transform:translateX(-24px);padding-left:var(--spacing-300);padding-right:var(--spacing-300);width:100%}@media (max-width: 768px){:host(.show-in-widget){padding-right:var(--spacing-300)}.sub-filters-wrapper,.selected-filters-wrapper{flex-wrap:unset;overflow-x:auto;padding-bottom:0}.sub-filters-wrapper,.selected-filters-wrapper{margin-top:16px;-webkit-overflow-scrolling:touch;scrollbar-width:none;-ms-overflow-style:none}.sub-filters-wrapper::-webkit-scrollbar,.selected-filters-wrapper::-webkit-scrollbar{display:none}.filters-modal.filters-modal-button .filters-modal-wrapper{width:100%;top:20%;border-radius:32px 32px 0px 0px}}.filters-sub-button{color:var(--color-text-primary);background:var(--surface-bg-color-01);padding:var(--spacing-100);gap:var(--spacing-25);height:100%}.filters-sub-button>span,.filters-sub-button-selected>span{display:inline-flex;justify-content:center;align-items:center;gap:var(--spacing-25);white-space:nowrap}.filters-sub-button>span>span,.filters-sub-button-selected>span>span{padding:var(--spacing-25)}.filters-sub-button:hover{background:var(--surface-bg-color-01-hover)}.filters-sub-button:disabled{cursor:not-allowed;background:var(--surface-bg-color-disabled);color:var(--color-text-disabled)}.filters-more-button{display:flex;padding:var(--spacing-100);gap:var(--spacing-50);border-radius:var(--border-radius-100);align-items:flex-start;background:var(--button-bg-color-secondary);border:none;cursor:pointer}.filters-modal.filters-modal-button{display:none;position:fixed;top:0;bottom:0;right:0;left:0;background-color:rgba(0, 0, 0, 0.5);z-index:98}.filters-modal.filters-modal-preview{display:block}.filters-modal.open{display:block}.filters-modal-wrapper{display:flex;flex-direction:column}.filters-modal.filters-modal-button .filters-modal-wrapper{position:fixed;top:0;bottom:0;right:0;width:420px;background-color:#ffffff;z-index:99;border-radius:var(--border-radius-400) var(--border-radius-none)\n    var(--border-radius-none) var(--border-radius-400)}.filters-modal-header{position:relative;padding:var(--spacing-250) 0;color:var(--color-text-primary);text-align:center;font-size:var(--font-size-headline);font-weight:var(--font-weight-500);line-height:var(--line-height-headline);letter-spacing:var(--letter-spacing-headline);border-bottom:1px solid var(--color-border-01);display:flex;justify-content:center;gap:5px}.filters-modal-list{margin:var(--spacing-50) 0 0 var(--spacing-300);flex:1;overflow-y:auto}.filters-modal-list>li{padding-right:var(--spacing-300)}.filters-modal-list>li:not(:last-child) .filters-modal-main-button-wrapper{border-bottom:1px solid var(--color-border-01)}.filters-modal-main-button{width:100%;background:none;text-align:left;padding:var(--spacing-200) 0;color:var(--color-text-primary);font-size:var(--font-size-label-large);font-weight:var(--font-weight-500);line-height:var(--line-height-label-large);letter-spacing:var(--letter-spacing-label-large)}.filters-modal-sub-list{display:none}.filters-modal-sub-list.open{display:flex;align-items:center;flex-wrap:wrap;gap:8px;padding-bottom:var(--spacing-150)}.filters-modal.filters-modal-button .filters-modal-close{position:absolute;right:0;top:var(--spacing-200);cursor:pointer;background:none}.filters-modal.filters-modal-preview .filters-modal-close{display:none}.filters-more-modal-button{background:none;border:none;cursor:pointer;display:flex;padding:var(--spacing-100);align-items:center;gap:var(--spacing-25);border-radius:var(--border-radius-100);background:var(--surface-bg-color-01);font-family:var(--font-family, var(--font-family-base));font-size:var(--font-size-label);color:var(--color-text-primary)}.filters-more-modal-button:hover{background:var(--surface-bg-color-01-hover)}.filters-more-modal-button.active{background:var(--surface-bg-color-inverse);color:var(--color-text-inverse)}.filters-more-modal-button>span{display:flex;align-items:center;justify-content:center;gap:var(--spacing-25)}.filters-more-modal-button>span>span{white-space:nowrap;padding:var(--spacing-25)}.filters-more-modal-button:disabled{cursor:not-allowed;opacity:0.5}.filters-modal-actions{border-top:1px solid var(--color-border-01);padding:var(--spacing-125);z-index:10;background:#ffffff;border-radius:0px 0px 0px 32px}.filters-modal-apply,.filters-modal-reset{font-family:var(--font-family, var(--font-family-base))}.filters-modal-apply{cursor:pointer;width:100%;border:none;margin-bottom:20px;display:flex;padding:var(--spacing-150);justify-content:center;align-items:center;gap:var(--spacing-50);align-self:stretch;color:var(--color-text-inverse);text-align:center;border-radius:var(--border-radius-150);background:var(--button-bg-color-primary);font-size:var(--font-size-label-large);font-weight:var(--font-weight-500);line-height:var(--line-height-label-large);letter-spacing:var(--letter-spacing-label-large)}.filters-modal-apply:disabled{background:var(--button-bg-color-disabled);color:var(--color-text-disabled)}.filters-modal-reset{background:none;border:none;cursor:pointer;display:block;text-align:center;width:100%;padding:var(--spacing-125) 0;color:var(--color-text-secondary);text-align:center;font-size:var(--font-size-label);font-weight:var(--font-weight-500);line-height:var(--line-height-label);letter-spacing:var(--letter-spacing-label)}.filters-modal-reset:hover{color:var(--color-text-primary)}.selected-filters-wrapper>li .filters-sub-button-selected{border-radius:var(--border-radius-100);background:var(--surface-bg-color-inverse);display:flex;align-items:center;justify-content:center;cursor:pointer;padding:var(--spacing-100)}.filters-sub-button-selected{display:flex;align-items:center;gap:var(--spacing-25);background:var(--surface-bg-color-inverse);border-radius:var(--border-radius-100);color:var(--color-text-inverse);text-overflow:ellipsis;font-size:var(--font-size-body);font-weight:var(--font-weight-400);line-height:var(--line-height-body);letter-spacing:var(--letter-spacing-body);padding:var(--spacing-100)}.filters-sub-button-color{width:40px;height:40px;border:var(--stroke-width-50) solid var(--color-border-01);border-radius:var(--border-radius-full);display:inline-block;box-sizing:border-box;position:relative}.filters-sub-button-color-dot{position:absolute;left:0;top:0;width:100%;height:100%;border-radius:var(--border-radius-full)}.filters-sub-button-color:disabled{opacity:0.25}.selected-filters-wrapper .filters-sub-button-selected.filters-sub-button-color{width:24px;height:24px;border:none}.filters-sub-button-color>span{display:none}.filters-sub-button-color.active{border:var(--stroke-width-75) solid var(--color-border-inverse-00);background-color:white}.filters-sub-button-color.active .filters-sub-button-color-dot{transform:scale(0.75)}.filters-modal-main-button-added-options{color:var(--color-text-secondary);text-overflow:ellipsis;font-size:var(--font-size-body);font-weight:var(--font-weight-400);line-height:var(--line-height-body);letter-spacing:var(--letter-spacing-body)}.filters-modal-main-button-added-options>span::after{content:\", \"}.filters-modal-main-button-added-options>span:last-child::after{content:\"\"}";

const VviinnExtendedFilters = class {
  constructor(hostRef) {
    index.registerInstance(this, hostRef);
    this.vviinnFiltersChanged = index.createEvent(this, "vviinnFiltersChanged", 7);
    this.vviinnFiltersReceived = index.createEvent(this, "vviinnFiltersReceived", 7);
    this.globalSlotsChanged = index.createEvent(this, "globalSlotsChanged", 7);
    this.vviinnSelectedFiltersReset = index.createEvent(this, "vviinnSelectedFiltersReset", 7);
    this.vviinnFilterTriggered = index.createEvent(this, "vviinnFilterTriggered", 7);
    this.getFilters = () => this.showInWidget ? this.filters : this.innerFilters;
    this.getSelectedPriceInterval = () => {
      var _a, _b;
      return ((_b = (_a = this.requestFilters.find(({ column }) => column === "price")) === null || _a === void 0 ? void 0 : _a.values[0]) !== null && _b !== void 0 ? _b : {});
    };
    this.handleSelectedFiltersReset = ({ detail, }) => {
      if (this.skipFiltersChanges(detail.isTriggeredByVpsWidget))
        return;
      this.requestFilters = [];
      this.selectedMoreOptions = [];
    };
    this.skipFiltersChanges = (isTriggeredByVpsWidget) => (isTriggeredByVpsWidget && !this.showInWidget) ||
      (!isTriggeredByVpsWidget && this.showInWidget);
    this.handleSetFilters = ({ detail }) => {
      if (this.showInWidget)
        return;
      this.innerFilters = detail;
    };
    this.handleFiltersChanged = ({ detail, }) => {
      const { filters, el: senderElement, isTriggeredByVpsWidget } = detail;
      if (senderElement === this.el ||
        this.skipFiltersChanges(isTriggeredByVpsWidget))
        return;
      this.requestFilters = filters;
    };
    this.priceChangeHandler = (filterValue) => {
      const selectedFilter = this.getFilters().find((filter) => filter.column === "price");
      if (selectedFilter) {
        this.handleSubFilterSelection(filterValue, selectedFilter);
      }
    };
    this.filters = [];
    this.locale = "de-DE";
    this.mode = "button";
    this.currencySign = "€";
    this.showHeader = true;
    this.filtersString = "";
    this.showInWidget = false;
    this.innerFilters = [];
    this.requestFilters = [];
    this.showMore = false;
    this.selectedMoreOptions = [];
  }
  replaceSlotsContent() {
    const slots = this.el.querySelectorAll("[slot]");
    this.globalSlotsChanged.emit({
      slots: Array.from(slots),
      element: this.el,
    });
  }
  componentDidRender() {
    this.replaceSlotsContent();
  }
  async componentWillLoad() {
    await index$2.instance.init({
      lng: this.locale,
      fallbackLng: "en",
      resources: index$2.resources,
    });
    _package.slotChangeListener(this, this.el);
  }
  handleSubFilterSelection(filterValue, selectedFilter) {
    this.requestFilters = triggerFilter.triggerFilter(filterValue, selectedFilter, this.requestFilters, this.vviinnFilterTriggered, this.vviinnFiltersChanged, this.el, this.showInWidget);
  }
  showActiveOnModalSubButton(requestFilters, filterValue) {
    let className = false;
    requestFilters.forEach((filter) => {
      if (filter.values.some((value) => value === filterValue ||
        value === filterValue.interval ||
        value === filterValue.value)) {
        className = true;
      }
    });
    return className;
  }
  handleMoreOptionsMainClick(column) {
    if (this.selectedMoreOptions.includes(column)) {
      this.selectedMoreOptions = this.selectedMoreOptions.filter((option) => option !== column);
    }
    else {
      this.selectedMoreOptions = [...this.selectedMoreOptions, column];
    }
  }
  filtersStringWatcher() {
    if (this.filtersString === "")
      return;
    try {
      this.filters = JSON.parse(this.filtersString);
    }
    catch (e) {
      console.error("Invalid filters string", e);
    }
  }
  connectedCallback() {
    document.addEventListener("vviinnFiltersReceived", this.handleSetFilters);
    document.addEventListener("vviinnFiltersChanged", this.handleFiltersChanged);
    document.addEventListener("vviinnSelectedFiltersReset", this.handleSelectedFiltersReset);
    this.filtersStringWatcher();
  }
  disconnectedCallback() {
    document.removeEventListener("vviinnFiltersReceived", this.handleSetFilters);
    document.addEventListener("vviinnFiltersChanged", this.handleFiltersChanged);
    document.addEventListener("vviinnSelectedFiltersReset", this.handleSelectedFiltersReset);
  }
  resetModal() {
    triggerFilter.triggerResetFilters(this.vviinnFiltersChanged, this.el, this.showInWidget);
    this.selectedMoreOptions = [];
    this.requestFilters = [];
    this.showMore = false;
  }
  getAsideElement() {
    return this.el.shadowRoot.querySelector("aside");
  }
  getSidebarRectangle() {
    var _a;
    return (_a = this.getAsideElement()) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
  }
  bodyClickListener(event) {
    if (this.mode !== "button")
      return;
    const sidebarRect = this.getSidebarRectangle();
    if (!sidebarRect || sidebarRect.width === 0 || sidebarRect.height === 0) {
      return;
    }
    if (!search_store.isClickedInRectBound(event, sidebarRect)) {
      this.showMore = false;
    }
  }
  render() {
    const filters = this.getFilters();
    return (index.h(index.Host, null, _package.SlotSkeleton("filters"), (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && this.mode === "button" && (index.h("button", { class: "filters-more-button", onClick: () => (this.showMore = true), part: "extended-filters-button" }, index.h(FiltersIcon, null))), index.h("div", { class: `filters-modal filters-modal-${this.mode} ${this.showMore ? "open" : ""}`, part: "extended-filters-modal" }, index.h("aside", { class: "filters-modal-wrapper", part: "extended-filters-modal-wrapper" }, this.showHeader && (index.h("div", { class: "filters-modal-header", part: "extended-filters-header" }, index.h("slot", { name: "vviinn-extended-filters-title" }, index.h("span", null, index$2.instance.t("filters.modal.title"))), index.h("button", { class: "filters-modal-close", onClick: () => {
        this.showMore = false;
        this.requestFilters = [];
      }, part: "extended-filters-modal-close" }, index.h(NewCloseIcon, null)))), index.h("ul", { class: "filters-modal-list", part: "extended-filters-list" }, (filters !== null && filters !== void 0 ? filters : []).map((mainFilter) => {
      var _a;
      const mainColumn = mainFilter.column;
      const filterOptions = getFilterOptions(mainFilter);
      const requestFilter = this.requestFilters.find(({ column }) => column === mainColumn);
      const addedOptions = [];
      (_a = requestFilter === null || requestFilter === void 0 ? void 0 : requestFilter.values) === null || _a === void 0 ? void 0 : _a.forEach((value) => {
        const index$1 = filterOptions.findIndex((f) => f.value.value === value || f.value === value);
        if (index$1 > -1) {
          addedOptions.push(index.h("span", null, filterOptions[index$1].label));
        }
      });
      return (index.h("li", { part: "extended-filters-row" }, index.h("div", { class: "filters-modal-main-button-wrapper", part: "extended-filters-row-wrapper" }, index.h("button", { onClick: () => this.handleMoreOptionsMainClick(mainFilter.column), class: "filters-modal-main-button", part: "extended-filters-main-button" }, mainFilter.label, addedOptions.length > 0 && (index.h("div", { class: "filters-modal-main-button-added-options", part: "extended-filters-selected-wrapper" }, addedOptions))), mainColumn === "price" &&
        this.selectedMoreOptions.includes(mainFilter.column) ? (index.h("vviinn-price-range", { histogram: filterOptions.filter((item) => item.value.frequency > 0), priceChangeHandler: this.priceChangeHandler, selectedInterval: this.getSelectedPriceInterval(), currencySign: this.currencySign })) : (index.h("ul", { class: `filters-modal-sub-list  ${this.selectedMoreOptions.includes(mainFilter.column)
          ? "open"
          : ""}`, part: "extended-filters-sub-list" }, !!filterOptions &&
        filterOptions.map(({ value, label, active }) => {
          const selected = this.showActiveOnModalSubButton(this.requestFilters, value);
          return triggerFilter.RenderButton(this.handleSubFilterSelection.bind(this), value, label, active, mainFilter, selected);
        }))))));
    })), index.h("div", { class: "filters-modal-actions", part: "extended-filters-actions" }, this.mode === "button" && (index.h("button", { class: "filters-modal-apply", onClick: () => (this.showMore = false), disabled: this.requestFilters.length === 0, part: "extended-filters-apply" }, index.h("slot", { name: "vviinn-extended-filters-apply" }, index$2.instance.t("filters.modal.apply")))), index.h("button", { class: "filters-modal-reset", onClick: () => this.resetModal(), part: "extended-filters-reset" }, index.h("slot", { name: "vviinn-extended-filters-reset" }, index$2.instance.t("filters.modal.resetFilters"))))))));
  }
  get el() { return index.getElement(this); }
  static get watchers() { return {
    "filtersString": ["filtersStringWatcher"]
  }; }
};
VviinnExtendedFilters.style = vviinnFiltersCss$1;

const vviinnFiltersCss = ":host{--font-family-base:Inter, system-ui, sans-serif;--font-family-mono:monospace;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;--font-size-title:24px;--font-size-headline:18px;--font-size-label-large:16px;--font-size-label:14px;--font-size-body-large:16px;--font-size-body:14px;--font-size-caption:12px;--line-height-title:32px;--line-height-headline:24px;--line-height-label-large:24px;--line-height-label:20px;--line-height-body-large:24px;--line-height-body:20px;--line-height-caption:16px;--letter-spacing-title:0px;--letter-spacing-headline:0px;--letter-spacing-label-large:0px;--letter-spacing-label:0px;--letter-spacing-body-large:0px;--letter-spacing-body:0px;--letter-spacing-caption:0px;--font-weight-400:400;--font-weight-500:500;--font-weight-600:600;--font-weight-700:700;--spacing-none:0px;--spacing-25:2px;--spacing-50:4px;--spacing-75:6px;--spacing-100:8px;--spacing-125:10px;--spacing-150:12px;--spacing-200:16px;--spacing-250:20px;--spacing-300:24px;--spacing-400:32px;--spacing-500:40px;--spacing-600:48px;--border-radius-none:0px;--border-radius-25:2px;--border-radius-50:4px;--border-radius-100:8px;--border-radius-150:12px;--border-radius-200:16px;--border-radius-300:24px;--border-radius-400:32px;--border-radius-full:9999px;--stroke-width-none:0px;--stroke-width-25:1px;--stroke-width-50:2px;--stroke-width-75:3px;--stroke-width-100:4px;--stroke-width-150:6px;--stroke-width-200:8px;--stroke-width-300:12px;--product-card-widget-min-width:135px;--product-card-results-min-width:250px;--image-set-mode-min-size:155px;--product-card-set-mode-max-width:300px;--source-card-set-mode-max-width:500px;--filter-blur-none:0px;--filter-blur-100:8px;--filter-blur-150:12px;--filter-blur-200:16px;--color-bg-base:#ffffff;--color-bg-inverse:#161616;--color-border-00:#ffffff;--color-border-01:#f4f4f4;--color-border-02:#e0e0e0;--color-border-03:#c6c6c6;--color-border-inverse-00:#161616;--color-border-inverse-01:#393939;--color-field-01:#ffffff;--color-field-02:#f4f4f4;--color-icon-primary:#161616;--color-icon-secondary:#525252;--color-icon-helper:#8d8d8d;--color-icon-on-color:#ffffff;--color-icon-inverse:#ffffff;--color-icon-disabled:#16161640;--color-text-primary:#161616;--color-text-secondary:#525252;--color-text-helper:#8d8d8d;--color-text-placeholder:#a8a8a8;--color-text-on-color:#ffffff;--color-text-inverse:#ffffff;--color-text-disabled:#16161640;--button-bg-color-primary:#000000;--button-bg-color-primary-hover:#161616;--button-bg-color-primary-active:#1e1e1e;--button-bg-color-secondary:#f4f4f4;--button-bg-color-secondary-hover:#e0e0e0;--button-bg-color-secondary-active:#c6c6c6;--button-bg-color-ghost-hover:#f4f4f4;--button-bg-color-ghost-active:#eaeaea;--button-bg-color-frosted:#6f6f6f66;--button-bg-color-frosted-hover:#6f6f6f80;--button-bg-color-frosted-active:#6f6f6f99;--button-bg-color-disabled:#e0e0e0;--button-bg-color-positive:#dcfce7;--surface-bg-color-01:#f4f4f4;--surface-bg-color-01-hover:#eaeaea;--surface-bg-color-01-active:#e0e0e0;--surface-bg-color-02:#ffffff;--surface-bg-color-inverse:#262626;--surface-bg-color-inverse-hover:#303030;--surface-bg-color-inverse-active:#393939;--surface-bg-color-disabled:#e0e0e0;--chip-bg-color-primary:#161616;--chip-bg-color-primary-hover:#1e1e1e;--chip-bg-color-primary-active:#262626;--chip-bg-color-subtle:#f4f4f4;--chip-bg-color-subtle-hover:#eaeaea;--chip-bg-color-subtle-active:#e0e0e0;--chip-bg-color-outline-hover:#f4f4f4;--chip-bg-color-outline-active:#eaeaea;--label-bg-color-accent:#ff3944;}:host{display:block;font-family:var(--font-family, var(--font-family-base));font-style:normal;}:host(.show-in-widget){padding-left:24px}.filters-modal-list,.sub-filters-wrapper,.main-filters-list,.filters-modal-sub-list,.selected-filters-wrapper{list-style:none;margin:0;padding:0}.main-filters-list{padding:var(--spacing-25);gap:var(--spacing-25);border-radius:8px;background:var(--surface-bg-color-01);display:inline-flex}vviinn-price-range{max-width:400px}:host(.show-in-widget) vviinn-price-range{max-width:unset}.filters-modal-main-button,.filters-sub-button,.filters-main-button,.filters-modal-close,.filters-sub-button-selected{font-family:var(--font-family, var(--font-family-base));cursor:pointer;border:none}.filters-sub-button,.filters-main-button{font-size:var(--font-size-body);font-weight:var(--font-weight-400);line-height:var(--line-height-body);letter-spacing:var(--letter-spacing-body);display:flex;justify-content:center;align-items:center;border-radius:6px}.filters-main-button{padding:var(--spacing-100);color:var(--color-text-helper);background:none}.filters-main-button.active,.filters-main-button:hover{background:var(--surface-bg-color-02);color:var(--color-text-primary)}.sub-filters-wrapper,.selected-filters-wrapper{gap:var(--spacing-100);display:flex;flex-direction:row;overflow-x:auto;scrollbar-width:thin;padding-bottom:6px}.sub-filters-wrapper{align-items:center;gap:var(--spacing-100);margin-top:16px;margin:16px -2px 0}.sub-filters-wrapper>li{padding:2px}.selected-filters-wrapper{margin-top:var(--spacing-125);gap:var(--spacing-100);flex-wrap:wrap}:host(.show-in-widget) .selected-filters-wrapper{flex-wrap:unset;overflow-x:auto}:host(.show-in-widget) .sub-filters-wrapper,:host(.show-in-widget) .selected-filters-wrapper{transform:translateX(-24px);padding-left:var(--spacing-300);padding-right:var(--spacing-300);width:100%}@media (max-width: 768px){:host(.show-in-widget){padding-right:var(--spacing-300)}.sub-filters-wrapper,.selected-filters-wrapper{flex-wrap:unset;overflow-x:auto;padding-bottom:0}.sub-filters-wrapper,.selected-filters-wrapper{margin-top:16px;-webkit-overflow-scrolling:touch;scrollbar-width:none;-ms-overflow-style:none}.sub-filters-wrapper::-webkit-scrollbar,.selected-filters-wrapper::-webkit-scrollbar{display:none}.filters-modal.filters-modal-button .filters-modal-wrapper{width:100%;top:20%;border-radius:32px 32px 0px 0px}}.filters-sub-button{color:var(--color-text-primary);background:var(--surface-bg-color-01);padding:var(--spacing-100);gap:var(--spacing-25);height:100%}.filters-sub-button>span,.filters-sub-button-selected>span{display:inline-flex;justify-content:center;align-items:center;gap:var(--spacing-25);white-space:nowrap}.filters-sub-button>span>span,.filters-sub-button-selected>span>span{padding:var(--spacing-25)}.filters-sub-button:hover{background:var(--surface-bg-color-01-hover)}.filters-sub-button:disabled{cursor:not-allowed;background:var(--surface-bg-color-disabled);color:var(--color-text-disabled)}.filters-more-button{display:flex;padding:var(--spacing-100);gap:var(--spacing-50);border-radius:var(--border-radius-100);align-items:flex-start;background:var(--button-bg-color-secondary);border:none;cursor:pointer}.filters-modal.filters-modal-button{display:none;position:fixed;top:0;bottom:0;right:0;left:0;background-color:rgba(0, 0, 0, 0.5);z-index:98}.filters-modal.filters-modal-preview{display:block}.filters-modal.open{display:block}.filters-modal-wrapper{display:flex;flex-direction:column}.filters-modal.filters-modal-button .filters-modal-wrapper{position:fixed;top:0;bottom:0;right:0;width:420px;background-color:#ffffff;z-index:99;border-radius:var(--border-radius-400) var(--border-radius-none)\n    var(--border-radius-none) var(--border-radius-400)}.filters-modal-header{position:relative;padding:var(--spacing-250) 0;color:var(--color-text-primary);text-align:center;font-size:var(--font-size-headline);font-weight:var(--font-weight-500);line-height:var(--line-height-headline);letter-spacing:var(--letter-spacing-headline);border-bottom:1px solid var(--color-border-01);display:flex;justify-content:center;gap:5px}.filters-modal-list{margin:var(--spacing-50) 0 0 var(--spacing-300);flex:1;overflow-y:auto}.filters-modal-list>li{padding-right:var(--spacing-300)}.filters-modal-list>li:not(:last-child) .filters-modal-main-button-wrapper{border-bottom:1px solid var(--color-border-01)}.filters-modal-main-button{width:100%;background:none;text-align:left;padding:var(--spacing-200) 0;color:var(--color-text-primary);font-size:var(--font-size-label-large);font-weight:var(--font-weight-500);line-height:var(--line-height-label-large);letter-spacing:var(--letter-spacing-label-large)}.filters-modal-sub-list{display:none}.filters-modal-sub-list.open{display:flex;align-items:center;flex-wrap:wrap;gap:8px;padding-bottom:var(--spacing-150)}.filters-modal.filters-modal-button .filters-modal-close{position:absolute;right:0;top:var(--spacing-200);cursor:pointer;background:none}.filters-modal.filters-modal-preview .filters-modal-close{display:none}.filters-more-modal-button{background:none;border:none;cursor:pointer;display:flex;padding:var(--spacing-100);align-items:center;gap:var(--spacing-25);border-radius:var(--border-radius-100);background:var(--surface-bg-color-01);font-family:var(--font-family, var(--font-family-base));font-size:var(--font-size-label);color:var(--color-text-primary)}.filters-more-modal-button:hover{background:var(--surface-bg-color-01-hover)}.filters-more-modal-button.active{background:var(--surface-bg-color-inverse);color:var(--color-text-inverse)}.filters-more-modal-button>span{display:flex;align-items:center;justify-content:center;gap:var(--spacing-25)}.filters-more-modal-button>span>span{white-space:nowrap;padding:var(--spacing-25)}.filters-more-modal-button:disabled{cursor:not-allowed;opacity:0.5}.filters-modal-actions{border-top:1px solid var(--color-border-01);padding:var(--spacing-125);z-index:10;background:#ffffff;border-radius:0px 0px 0px 32px}.filters-modal-apply,.filters-modal-reset{font-family:var(--font-family, var(--font-family-base))}.filters-modal-apply{cursor:pointer;width:100%;border:none;margin-bottom:20px;display:flex;padding:var(--spacing-150);justify-content:center;align-items:center;gap:var(--spacing-50);align-self:stretch;color:var(--color-text-inverse);text-align:center;border-radius:var(--border-radius-150);background:var(--button-bg-color-primary);font-size:var(--font-size-label-large);font-weight:var(--font-weight-500);line-height:var(--line-height-label-large);letter-spacing:var(--letter-spacing-label-large)}.filters-modal-apply:disabled{background:var(--button-bg-color-disabled);color:var(--color-text-disabled)}.filters-modal-reset{background:none;border:none;cursor:pointer;display:block;text-align:center;width:100%;padding:var(--spacing-125) 0;color:var(--color-text-secondary);text-align:center;font-size:var(--font-size-label);font-weight:var(--font-weight-500);line-height:var(--line-height-label);letter-spacing:var(--letter-spacing-label)}.filters-modal-reset:hover{color:var(--color-text-primary)}.selected-filters-wrapper>li .filters-sub-button-selected{border-radius:var(--border-radius-100);background:var(--surface-bg-color-inverse);display:flex;align-items:center;justify-content:center;cursor:pointer;padding:var(--spacing-100)}.filters-sub-button-selected{display:flex;align-items:center;gap:var(--spacing-25);background:var(--surface-bg-color-inverse);border-radius:var(--border-radius-100);color:var(--color-text-inverse);text-overflow:ellipsis;font-size:var(--font-size-body);font-weight:var(--font-weight-400);line-height:var(--line-height-body);letter-spacing:var(--letter-spacing-body);padding:var(--spacing-100)}.filters-sub-button-color{width:40px;height:40px;border:var(--stroke-width-50) solid var(--color-border-01);border-radius:var(--border-radius-full);display:inline-block;box-sizing:border-box;position:relative}.filters-sub-button-color-dot{position:absolute;left:0;top:0;width:100%;height:100%;border-radius:var(--border-radius-full)}.filters-sub-button-color:disabled{opacity:0.25}.selected-filters-wrapper .filters-sub-button-selected.filters-sub-button-color{width:24px;height:24px;border:none}.filters-sub-button-color>span{display:none}.filters-sub-button-color.active{border:var(--stroke-width-75) solid var(--color-border-inverse-00);background-color:white}.filters-sub-button-color.active .filters-sub-button-color-dot{transform:scale(0.75)}.filters-modal-main-button-added-options{color:var(--color-text-secondary);text-overflow:ellipsis;font-size:var(--font-size-body);font-weight:var(--font-weight-400);line-height:var(--line-height-body);letter-spacing:var(--letter-spacing-body)}.filters-modal-main-button-added-options>span::after{content:\", \"}.filters-modal-main-button-added-options>span:last-child::after{content:\"\"}";

const VviinnFilters = class {
  constructor(hostRef) {
    index.registerInstance(this, hostRef);
    this.vviinnFiltersChanged = index.createEvent(this, "vviinnFiltersChanged", 7);
    this.vviinnFiltersReceived = index.createEvent(this, "vviinnFiltersReceived", 7);
    this.vviinnFilterTriggered = index.createEvent(this, "vviinnFilterTriggered", 7);
    this.globalSlotsChanged = index.createEvent(this, "globalSlotsChanged", 7);
    this.vviinnSelectedFiltersReset = index.createEvent(this, "vviinnSelectedFiltersReset", 7);
    this.getSelectedPriceInterval = () => {
      var _a, _b;
      return ((_b = (_a = this.requestFilters.find(({ column }) => column === "price")) === null || _a === void 0 ? void 0 : _a.values[0]) !== null && _b !== void 0 ? _b : {});
    };
    this.getFilters = () => this.showInWidget ? this.filters : this.innerFilters;
    this.handleSelectedFiltersReset = ({ detail, }) => {
      if (this.skipFiltersChanges(detail.isTriggeredByVpsWidget))
        return;
      this.requestFilters = [];
      this.selectedFilter = undefined;
    };
    this.skipFiltersChanges = (isTriggeredByVpsWidget) => (isTriggeredByVpsWidget && !this.showInWidget) ||
      (!isTriggeredByVpsWidget && this.showInWidget);
    this.priceChangeHandler = (filterValue) => {
      this.handleSubFilterSelection(filterValue, this.selectedFilter);
    };
    this.handleSetFilters = ({ detail, }) => {
      var _a;
      if (this.showInWidget)
        return;
      this.innerFilters = detail;
      if (!((_a = this.innerFilters) === null || _a === void 0 ? void 0 : _a.length))
        return;
      if (this.selectedFilter) {
        this.selectedFilter = this.innerFilters.find((f) => f.column === this.selectedFilter.column);
      }
      if (!detail.some(({ column }) => { var _a; return column === ((_a = this.selectedFilter) === null || _a === void 0 ? void 0 : _a.column); })) {
        this.selectedFilter = undefined;
      }
    };
    this.handleFiltersChanged = ({ detail, }) => {
      const { filters, el: senderElement, isTriggeredByVpsWidget } = detail;
      if (senderElement === this.el ||
        this.skipFiltersChanges(isTriggeredByVpsWidget))
        return;
      this.requestFilters = filters;
      if (!this.selectedFilter) {
        this.selectedFilter = this.getFilters().find((f) => f.column === filters[0].column);
      }
    };
    this.filters = [];
    this.filtersString = "";
    this.showInWidget = false;
    this.currencySign = "€";
    this.innerFilters = [];
    this.selectedFilter = undefined;
    this.requestFilters = [];
  }
  handleMainFilterSelection(filter) {
    this.selectedFilter = filter;
  }
  handleSubFilterSelection(filterValue, selectedFilter) {
    this.requestFilters = triggerFilter.triggerFilter(filterValue, selectedFilter, this.requestFilters, this.vviinnFilterTriggered, this.vviinnFiltersChanged, this.el, this.showInWidget);
  }
  showActiveOnMainButton({ column }) {
    if (!this.selectedFilter)
      return "";
    return this.selectedFilter.column === column ? "active" : "";
  }
  filtersStringWatcher() {
    if (this.filtersString === "")
      return;
    try {
      this.innerFilters = JSON.parse(this.filtersString);
    }
    catch (e) {
      console.error("Invalid filters string", e);
    }
  }
  connectedCallback() {
    document.addEventListener("vviinnFiltersReceived", this.handleSetFilters);
    document.addEventListener("vviinnFiltersChanged", this.handleFiltersChanged);
    document.addEventListener("vviinnSelectedFiltersReset", this.handleSelectedFiltersReset);
    this.filtersStringWatcher();
  }
  disconnectedCallback() {
    document.removeEventListener("vviinnFiltersReceived", this.handleSetFilters);
    document.removeEventListener("vviinnFiltersChanged", this.handleFiltersChanged);
    document.removeEventListener("vviinnSelectedFiltersReset", this.handleSelectedFiltersReset);
  }
  render() {
    var _a;
    const filters = this.getFilters().filter((filter) => filter.isPrimary);
    if (!(filters === null || filters === void 0 ? void 0 : filters.length))
      return index.h(index.Host, null);
    const { column } = (_a = this.selectedFilter) !== null && _a !== void 0 ? _a : {};
    const filterOptions = getFilterOptions(this.selectedFilter);
    return (index.h(index.Host, { class: {
        "show-in-widget": this.showInWidget,
      } }, index.h("div", { class: "main-filters-wrapper", part: "filters-wrapper" }, index.h("ul", { class: "main-filters-list", part: "filters-list" }, filters.map((filter) => {
      return (index.h("li", null, index.h("button", { class: `filters-main-button ${this.showActiveOnMainButton(filter)}`, onClick: () => this.handleMainFilterSelection(filter), part: "filters-main-button" }, filter.label)));
    }))), !!this.selectedFilter && (index.h("div", { class: "filters-footer", part: "filters-footer" }, column === "price" ? (index.h("vviinn-price-range", { histogram: filterOptions.filter((item) => item.value.frequency > 0), priceChangeHandler: this.priceChangeHandler, selectedInterval: this.getSelectedPriceInterval(), currencySign: this.currencySign })) : (index.h("ul", { class: "sub-filters-wrapper", part: "filters-footer-list" }, !!filterOptions &&
      filterOptions.map(({ value, label, active }) => {
        const isSelected = triggerFilter.showActiveOnSubButton(this.requestFilters, value, this.selectedFilter);
        return triggerFilter.RenderButton(this.handleSubFilterSelection.bind(this), value, label, active, this.selectedFilter, isSelected);
      })))))));
  }
  get el() { return index.getElement(this); }
  static get watchers() { return {
    "filtersString": ["filtersStringWatcher"]
  }; }
};
VviinnFilters.style = vviinnFiltersCss;

const vviinnPriceRangeCss = ":host{--font-family-base:Inter, system-ui, sans-serif;--font-family-mono:monospace;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;--font-size-title:24px;--font-size-headline:18px;--font-size-label-large:16px;--font-size-label:14px;--font-size-body-large:16px;--font-size-body:14px;--font-size-caption:12px;--line-height-title:32px;--line-height-headline:24px;--line-height-label-large:24px;--line-height-label:20px;--line-height-body-large:24px;--line-height-body:20px;--line-height-caption:16px;--letter-spacing-title:0px;--letter-spacing-headline:0px;--letter-spacing-label-large:0px;--letter-spacing-label:0px;--letter-spacing-body-large:0px;--letter-spacing-body:0px;--letter-spacing-caption:0px;--font-weight-400:400;--font-weight-500:500;--font-weight-600:600;--font-weight-700:700;--spacing-none:0px;--spacing-25:2px;--spacing-50:4px;--spacing-75:6px;--spacing-100:8px;--spacing-125:10px;--spacing-150:12px;--spacing-200:16px;--spacing-250:20px;--spacing-300:24px;--spacing-400:32px;--spacing-500:40px;--spacing-600:48px;--border-radius-none:0px;--border-radius-25:2px;--border-radius-50:4px;--border-radius-100:8px;--border-radius-150:12px;--border-radius-200:16px;--border-radius-300:24px;--border-radius-400:32px;--border-radius-full:9999px;--stroke-width-none:0px;--stroke-width-25:1px;--stroke-width-50:2px;--stroke-width-75:3px;--stroke-width-100:4px;--stroke-width-150:6px;--stroke-width-200:8px;--stroke-width-300:12px;--product-card-widget-min-width:135px;--product-card-results-min-width:250px;--image-set-mode-min-size:155px;--product-card-set-mode-max-width:300px;--source-card-set-mode-max-width:500px;--filter-blur-none:0px;--filter-blur-100:8px;--filter-blur-150:12px;--filter-blur-200:16px;--color-bg-base:#ffffff;--color-bg-inverse:#161616;--color-border-00:#ffffff;--color-border-01:#f4f4f4;--color-border-02:#e0e0e0;--color-border-03:#c6c6c6;--color-border-inverse-00:#161616;--color-border-inverse-01:#393939;--color-field-01:#ffffff;--color-field-02:#f4f4f4;--color-icon-primary:#161616;--color-icon-secondary:#525252;--color-icon-helper:#8d8d8d;--color-icon-on-color:#ffffff;--color-icon-inverse:#ffffff;--color-icon-disabled:#16161640;--color-text-primary:#161616;--color-text-secondary:#525252;--color-text-helper:#8d8d8d;--color-text-placeholder:#a8a8a8;--color-text-on-color:#ffffff;--color-text-inverse:#ffffff;--color-text-disabled:#16161640;--button-bg-color-primary:#000000;--button-bg-color-primary-hover:#161616;--button-bg-color-primary-active:#1e1e1e;--button-bg-color-secondary:#f4f4f4;--button-bg-color-secondary-hover:#e0e0e0;--button-bg-color-secondary-active:#c6c6c6;--button-bg-color-ghost-hover:#f4f4f4;--button-bg-color-ghost-active:#eaeaea;--button-bg-color-frosted:#6f6f6f66;--button-bg-color-frosted-hover:#6f6f6f80;--button-bg-color-frosted-active:#6f6f6f99;--button-bg-color-disabled:#e0e0e0;--button-bg-color-positive:#dcfce7;--surface-bg-color-01:#f4f4f4;--surface-bg-color-01-hover:#eaeaea;--surface-bg-color-01-active:#e0e0e0;--surface-bg-color-02:#ffffff;--surface-bg-color-inverse:#262626;--surface-bg-color-inverse-hover:#303030;--surface-bg-color-inverse-active:#393939;--surface-bg-color-disabled:#e0e0e0;--chip-bg-color-primary:#161616;--chip-bg-color-primary-hover:#1e1e1e;--chip-bg-color-primary-active:#262626;--chip-bg-color-subtle:#f4f4f4;--chip-bg-color-subtle-hover:#eaeaea;--chip-bg-color-subtle-active:#e0e0e0;--chip-bg-color-outline-hover:#f4f4f4;--chip-bg-color-outline-active:#eaeaea;--label-bg-color-accent:#ff3944;}:host{display:block;margin-top:var(--spacing-300);font-family:var(--font-family, var(--font-family-base));--thumb-size:32px}.histogram{height:64px;display:flex;align-items:flex-end;gap:2px;padding:0 12px}.histogram-bar{background:var(--surface-inverse-bg-color, #262626);flex:1;border-radius:2px 2px 0px 0px}.histogram-bar.histogram-bar-inactive{background:var(--surface-bg-color-disabled)}.range_container{display:flex;flex-direction:column;width:100%;margin-top:-2px;transform:translateX(-2px)}.range_container .sliders_control{position:relative;min-height:25px}.range_container .form_control{position:relative;display:flex;justify-content:space-between;font-size:24px;color:#635a5a}.range_container input[type=\"range\"]{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:1px;width:100%;position:absolute;background:var(--color-border-02);pointer-events:none}.range_container input[type=\"range\"]::-webkit-slider-thumb{-webkit-appearance:none;pointer-events:all;width:var(--thumb-size);height:var(--thumb-size);background-color:var(--color-bg-base);border-radius:50%;border:1px solid var(--color-border-03);cursor:pointer}.range_container input[type=\"range\"]::-moz-range-thumb{-webkit-appearance:none;pointer-events:all;width:var(--thumb-size);height:var(--thumb-size);background-color:var(--color-bg-base);border-radius:50%;border:1px solid var(--color-border-02);cursor:pointer}.range_container input[type=\"range\"]::-webkit-slider-thumb:hover{background:#f7f7f7}.range_container #fromSlider{z-index:1;background:transparent}.label-wrapper{display:flex;justify-content:space-between;margin-top:6px}.label-wrapper .label{display:flex;padding:var(--spacing-25) var(--spacing-100);justify-content:center;align-items:center;border-radius:var(--border-radius-100);background:var(--chip-bg-color-primary);color:var(--color-text-inverse);text-align:center;font-size:var(--font-size-label);font-style:normal;font-weight:var(--font-weight-500);line-height:var(--line-height-label);letter-spacing:var(--letter-spacing-label);gap:3px}";

const MIN_BAR_HEIGHT = 3;
const VviinnButton = class {
  constructor(hostRef) {
    index.registerInstance(this, hostRef);
    this.histogram = [];
    this.addStyle = true;
    this.priceChangeHandler = undefined;
    this.selectedInterval = undefined;
    this.currencySign = undefined;
    this.minIndex = 0;
    this.maxIndex = undefined;
    this.scalingFactor = undefined;
  }
  componentWillLoad() {
    this.updatingSelectedInterval();
  }
  updatingSelectedInterval() {
    this.maxIndex = this.histogram.length - 1;
    const maxValueofFrequency = Math.max(...this.histogram.map(({ value }) => {
      return value.frequency;
    }));
    this.scalingFactor = 100 / maxValueofFrequency;
    if (this.selectedInterval.start !== undefined) {
      this.minIndex = this.histogram.findIndex(({ value }) => value.interval.start === this.selectedInterval.start);
    }
    else {
      this.minIndex = 0;
    }
    if (this.selectedInterval.end) {
      this.maxIndex = this.histogram.findIndex((item) => item.value.interval.end === this.selectedInterval.end);
    }
    else {
      this.maxIndex = this.histogram.length - 1;
    }
  }
  controlFromSlider(e) {
    const fromValue = parseInt(e.target.value);
    if (fromValue >= this.maxIndex) {
      this.minIndex = this.maxIndex - 1; // Set it just below max index
    }
    else {
      this.minIndex = fromValue;
    }
    e.target.value = String(this.minIndex);
  }
  controlToSlider(e) {
    const toValue = parseInt(e.target.value);
    if (toValue <= this.minIndex) {
      this.maxIndex = this.minIndex + 1;
    }
    else {
      this.maxIndex = toValue;
    }
    e.target.value = String(this.maxIndex);
  }
  sendBackValue() {
    var _a, _b, _c, _d, _e, _f;
    this.priceChangeHandler({
      interval: {
        start: (_c = (_b = (_a = this.histogram[this.minIndex]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.interval) === null || _c === void 0 ? void 0 : _c.start,
        end: (_f = (_e = (_d = this.histogram[this.maxIndex]) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.interval) === null || _f === void 0 ? void 0 : _f.end,
      },
    });
  }
  calculateBarHeight(frequency) {
    return frequency * this.scalingFactor;
  }
  render() {
    var _a, _b, _c, _d, _e, _f;
    const histogramSize = this.histogram.length - 1;
    return (index.h(index.Host, { exportparts: index$3.priceRangeParts }, index.h("div", { class: "histogram", part: "histogram" }, this.histogram.map((item, index$1) => {
      const barHeight = this.calculateBarHeight(item.value.frequency);
      return (index.h("div", { class: `histogram-bar ${index$1 < this.minIndex || index$1 > this.maxIndex
          ? "histogram-bar-inactive"
          : ""}`, style: {
          height: `${barHeight && barHeight < MIN_BAR_HEIGHT
            ? MIN_BAR_HEIGHT
            : barHeight}%`,
        }, part: "histogram-bar" }));
    })), index.h("div", { class: "range_container", part: "histogram-range-container" }, index.h("div", { class: "sliders_control", part: "histogram-sliders-control" }, index.h("input", { ref: (el) => (this.fromSlider = el), id: "fromSlider", type: "range", min: "0", max: histogramSize, value: this.minIndex, onInput: (e) => {
        this.controlFromSlider(e);
      }, onChange: () => this.sendBackValue(), part: "histogram-from-slider" }), index.h("input", { ref: (el) => (this.toSlider = el), id: "toSlider", type: "range", min: "0", max: histogramSize, value: this.maxIndex, onInput: (e) => {
        this.controlToSlider(e);
      }, onChange: () => this.sendBackValue(), part: "histogram-to-slider" }))), index.h("div", { class: "label-wrapper", part: "histogram-label-wrapper" }, index.h("div", { class: "label", part: "histogram-label" }, (_c = (_b = (_a = this.histogram[this.minIndex]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.interval) === null || _c === void 0 ? void 0 :
      _c.start, index.h("span", { class: "histogram-currency" }, this.currencySign)), index.h("div", { class: "label", part: "histogram-label" }, (_f = (_e = (_d = this.histogram[this.maxIndex]) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.interval) === null || _f === void 0 ? void 0 :
      _f.end, index.h("span", { class: "histogram-currency" }, this.currencySign)))));
  }
  get el() { return index.getElement(this); }
  static get watchers() { return {
    "selectedInterval": ["updatingSelectedInterval"]
  }; }
};
VviinnButton.style = vviinnPriceRangeCss;

class GtagAnalytics {
  sendImpression(product) {
    var _a, _b, _c;
    if (!product)
      return undefined;
    gtag("event", "view_item_list", {
      items: [
        {
          id: product.productId,
          name: product.title,
          brand: (_a = product.brand) !== null && _a !== void 0 ? _a : "",
          category: (_b = product.productType) !== null && _b !== void 0 ? _b : "",
          list_name: "VI VPR View",
          price: Math.min(...[product.price.actual, (_c = product.price.sale) !== null && _c !== void 0 ? _c : Infinity]),
        },
      ],
    });
    return undefined;
  }
  sendClick(product) {
    var _a, _b, _c;
    gtag("event", "select_content", {
      content_type: "product",
      items: [
        {
          id: product.productId,
          name: product.title,
          brand: (_a = product.brand) !== null && _a !== void 0 ? _a : "",
          category: (_b = product.productType) !== null && _b !== void 0 ? _b : "",
          list_name: "VI VPR View",
          price: Math.min(...[product.price.actual, (_c = product.price.sale) !== null && _c !== void 0 ? _c : Infinity]),
        },
      ],
    });
    return undefined;
  }
}

class GAnalytics {
  constructor() {
    ga("require", "ec");
  }
  convertProduct(product) {
    var _a, _b, _c;
    return {
      id: product.productId,
      name: product.title,
      brand: (_a = product.brand) !== null && _a !== void 0 ? _a : "",
      category: (_b = product.productType) !== null && _b !== void 0 ? _b : "",
      list: "VI VPR View",
      price: Math.min(...[product.price.actual, (_c = product.price.sale) !== null && _c !== void 0 ? _c : Infinity]),
    };
  }
  sendImpression(product) {
    ga("ec:addImpression", this.convertProduct(product));
    return undefined;
  }
  sendClick(product) {
    var _a, _b, _c;
    ga("ec:addProduct", {
      id: product.productId,
      name: product.title,
      brand: (_a = product.brand) !== null && _a !== void 0 ? _a : "",
      category: (_b = product.productType) !== null && _b !== void 0 ? _b : "",
      price: Math.min(...[product.price.actual, (_c = product.price.sale) !== null && _c !== void 0 ? _c : Infinity]),
    });
    ga("ec:setAction", "click", { list: "VI VPR View" });
    return undefined;
  }
}

const getGtagAnalytics = () => search_store._function.pipe(search_store.Option.fromNullable(window.gtag), search_store.Option.map(() => new GtagAnalytics()));
const getCommonAnalytics = () => search_store._function.pipe(search_store.Option.fromNullable(window.ga), search_store.Option.map(() => new GAnalytics()));
const analyticsMonoid = search_store.Option.getMonoid(search_store.Semigroup.first());
const getAnalyticsModule = analyticsMonoid.concat(getGtagAnalytics(), getCommonAnalytics());

const FIT_EXPR = /fit\/\d+\//;
const containsFit = (url) => {
  return search_store._function.pipe(url.match(FIT_EXPR), search_store.Either.fromNullable(url), search_store.Either.map(() => url));
};
const processWidth = (url, size) => {
  return search_store._function.pipe(containsFit(url), search_store.Either.map((url) => url.replace(FIT_EXPR, `fit/${size}/`)), search_store.Either.getOrElse(() => url));
};
const Linked = (props, child) => props.deeplink ? (index.h("a", { class: props.part, part: props.part, href: props.deeplink }, child)) : (child);
const getFormattedPrice = (price, locale) => price
  ? new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price)
  : null;
const FormattedPrice = (props) => {
  const priceType = props.priceType;
  const formattedPrice = getFormattedPrice(props.price, props.locale);
  const prefixElement = props.prefix ? (index.h("span", { part: "price-prefix" }, props.prefix + " ")) : null;
  const currencyElement = props.currency ? (index.h("span", { part: "currency", class: "currency" }, props.currency)) : null;
  return (index.h("span", { class: "price-amount", part: `price-amount${priceType ? "-" + priceType : ""}` },
    prefixElement,
    formattedPrice,
    currencyElement));
};
const FormattedBasePrice = ({ currency, basePrice, priceType, locale, }) => {
  if (!(basePrice === null || basePrice === void 0 ? void 0 : basePrice.price))
    return null;
  const formattedPrice = getFormattedPrice(basePrice.price, locale);
  return (index.h("span", { class: "price-amount price-amount--base", part: `price-amount-base${priceType ? "-" + priceType : ""}` },
    formattedPrice,
    (currency === null || currency === void 0 ? void 0 : currency.length) > 0 && (index.h("span", { part: "currency", class: "currency" }, currency)),
    "/",
    (basePrice === null || basePrice === void 0 ? void 0 : basePrice.quantity) > 1 && (basePrice === null || basePrice === void 0 ? void 0 : basePrice.quantity), basePrice === null || basePrice === void 0 ? void 0 :
    basePrice.measure));
};
const parseBasePrice = (basePrice) => {
  if (!basePrice)
    return null;
  if (typeof basePrice === "string") {
    return JSON.parse(basePrice);
  }
  return basePrice;
};
const renderCustomLabels = (labels) => {
  const renderLabel = (label, index$1) => label ? (index.h("span", { part: `custom-label-${index$1}`, class: "custom-label" }, label)) : null;
  return (index.h(index.Fragment, null, labels.map((label, index) => renderLabel(label, index))));
};
const Price = (props) => {
  const renderPrice = () => props.salePrice ? ([
    index.h("span", { class: "price-outdated", part: "price-outdated" },
      index.h(FormattedPrice, { prefix: props.prefix, currency: props.currency, price: props.price, locale: props.locale, priceType: "outdated" }),
      index.h(FormattedBasePrice, { currency: props.currency, basePrice: props.basePrice, locale: props.locale, priceType: "outdated" })),
    index.h("span", { class: "price-sale", part: "price-sale" },
      index.h(FormattedPrice, { prefix: props.prefix, currency: props.currency, price: props.salePrice, locale: props.locale, priceType: "sale" }),
      index.h(FormattedBasePrice, { currency: props.currency, basePrice: props.baseSalePrice, locale: props.locale, priceType: "sale" })),
  ]) : (index.h("span", { class: "price-regular", part: "price-regular" },
    index.h(FormattedPrice, { prefix: props.prefix, currency: props.currency, price: props.price, locale: props.locale, priceType: "regular" }),
    index.h(FormattedBasePrice, { currency: props.currency, basePrice: props.basePrice, locale: props.locale, priceType: "regular" })));
  return props.showInContainer ? (index.h("div", { class: "price-container", part: "price-container" }, renderPrice())) : (renderPrice());
};
const Image = (props, onLoadEnd = () => undefined) => (index.h("picture", { part: "image-picture" },
  index.h("img", { loading: props.lazy ? "lazy" : "eager", part: "image", class: "image", width: props.width, height: props.height, src: processWidth(props.src, props.width), alt: props.title, ref: props.ref, onLoad: onLoadEnd }),
  props.isSource && index.h(index$1.PlusIcon, null)));
const ResponsiveImage = (props, onLoadEnd = () => undefined) => (index.h("picture", { part: "image-picture" },
  index.h("img", { loading: props.lazy ? "lazy" : "eager", part: "image", class: "image responsive", src: processWidth(props.src, props.width), alt: props.title, ref: props.ref, onLoad: onLoadEnd })));

const vviinnProductCardCss = ":host{--font-family-base:Inter, system-ui, sans-serif;--font-family-mono:monospace;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;--font-size-title:24px;--font-size-headline:18px;--font-size-label-large:16px;--font-size-label:14px;--font-size-body-large:16px;--font-size-body:14px;--font-size-caption:12px;--line-height-title:32px;--line-height-headline:24px;--line-height-label-large:24px;--line-height-label:20px;--line-height-body-large:24px;--line-height-body:20px;--line-height-caption:16px;--letter-spacing-title:0px;--letter-spacing-headline:0px;--letter-spacing-label-large:0px;--letter-spacing-label:0px;--letter-spacing-body-large:0px;--letter-spacing-body:0px;--letter-spacing-caption:0px;--font-weight-400:400;--font-weight-500:500;--font-weight-600:600;--font-weight-700:700;--spacing-none:0px;--spacing-25:2px;--spacing-50:4px;--spacing-75:6px;--spacing-100:8px;--spacing-125:10px;--spacing-150:12px;--spacing-200:16px;--spacing-250:20px;--spacing-300:24px;--spacing-400:32px;--spacing-500:40px;--spacing-600:48px;--border-radius-none:0px;--border-radius-25:2px;--border-radius-50:4px;--border-radius-100:8px;--border-radius-150:12px;--border-radius-200:16px;--border-radius-300:24px;--border-radius-400:32px;--border-radius-full:9999px;--stroke-width-none:0px;--stroke-width-25:1px;--stroke-width-50:2px;--stroke-width-75:3px;--stroke-width-100:4px;--stroke-width-150:6px;--stroke-width-200:8px;--stroke-width-300:12px;--product-card-widget-min-width:135px;--product-card-results-min-width:250px;--image-set-mode-min-size:155px;--product-card-set-mode-max-width:300px;--source-card-set-mode-max-width:500px;--filter-blur-none:0px;--filter-blur-100:8px;--filter-blur-150:12px;--filter-blur-200:16px;--color-bg-base:#ffffff;--color-bg-inverse:#161616;--color-border-00:#ffffff;--color-border-01:#f4f4f4;--color-border-02:#e0e0e0;--color-border-03:#c6c6c6;--color-border-inverse-00:#161616;--color-border-inverse-01:#393939;--color-field-01:#ffffff;--color-field-02:#f4f4f4;--color-icon-primary:#161616;--color-icon-secondary:#525252;--color-icon-helper:#8d8d8d;--color-icon-on-color:#ffffff;--color-icon-inverse:#ffffff;--color-icon-disabled:#16161640;--color-text-primary:#161616;--color-text-secondary:#525252;--color-text-helper:#8d8d8d;--color-text-placeholder:#a8a8a8;--color-text-on-color:#ffffff;--color-text-inverse:#ffffff;--color-text-disabled:#16161640;--button-bg-color-primary:#000000;--button-bg-color-primary-hover:#161616;--button-bg-color-primary-active:#1e1e1e;--button-bg-color-secondary:#f4f4f4;--button-bg-color-secondary-hover:#e0e0e0;--button-bg-color-secondary-active:#c6c6c6;--button-bg-color-ghost-hover:#f4f4f4;--button-bg-color-ghost-active:#eaeaea;--button-bg-color-frosted:#6f6f6f66;--button-bg-color-frosted-hover:#6f6f6f80;--button-bg-color-frosted-active:#6f6f6f99;--button-bg-color-disabled:#e0e0e0;--button-bg-color-positive:#dcfce7;--surface-bg-color-01:#f4f4f4;--surface-bg-color-01-hover:#eaeaea;--surface-bg-color-01-active:#e0e0e0;--surface-bg-color-02:#ffffff;--surface-bg-color-inverse:#262626;--surface-bg-color-inverse-hover:#303030;--surface-bg-color-inverse-active:#393939;--surface-bg-color-disabled:#e0e0e0;--chip-bg-color-primary:#161616;--chip-bg-color-primary-hover:#1e1e1e;--chip-bg-color-primary-active:#262626;--chip-bg-color-subtle:#f4f4f4;--chip-bg-color-subtle-hover:#eaeaea;--chip-bg-color-subtle-active:#e0e0e0;--chip-bg-color-outline-hover:#f4f4f4;--chip-bg-color-outline-active:#eaeaea;--label-bg-color-accent:#ff3944;}:host{--product-card-content-align-default:flex-start;--product-card-text-align-default:left;--product-card-image-border-default:none;--product-card-image-bg-color-default:var(--surface-bg-color-01);--basket-button-bg-color-pressed-default:var(--button-bg-color-positive);position:relative;height:-moz-fit-content;height:fit-content;display:flex;flex-direction:column;align-items:var(\n    --product-card-content-align,\n    var(--product-card-content-align-default)\n  );text-align:var(\n    --product-card-text-align,\n    var(--product-card-text-align-default)\n  );font-family:var(--font-family, var(--font-family-base));font-weight:var(--font-weight-400);font-size:var(--font-size-body);line-height:var(--line-height-body);font-style:normal;color:var(--color-text-primary);gap:var(--spacing-100)}.image-container{position:relative;height:100%;width:100%}.basket-button-container{width:100%;display:flex;justify-content:var(\n    --product-card-content-align,\n    var(--product-card-content-align-default)\n  )}.content-container{display:grid;width:100%;grid-template-columns:1fr;align-items:var(\n    --product-card-content-align,\n    var(--product-card-content-align-default)\n  );gap:var(--spacing-50)}.price-container{display:flex;flex-direction:column;gap:var(--spacing-50);flex-wrap:wrap;justify-content:var(\n    --product-card-content-align,\n    var(--product-card-content-align-default)\n  )}.price-outdated,.price-sale,.price-regular{justify-content:var(\n    --product-card-content-align,\n    var(--product-card-content-align-default)\n  );display:flex;gap:var(--spacing-100);flex-wrap:wrap}.price-outdated{color:var(--color-text-helper);text-decoration:line-through}.custom-label{font-weight:var(--font-weight-600);display:none}.price-amount,.custom-label>span,.currency{white-space:nowrap}.custom-label>span{margin-right:var(--spacing-75)}.price-amount--base{color:var(--color-text-helper);font-size:var(--font-size-caption)}.product-type{word-wrap:anywhere}.image{box-sizing:border-box;display:grid;align-content:center;-o-object-position:50% 50%;object-position:50% 50%;aspect-ratio:1;-o-object-fit:contain;object-fit:contain;text-align:center;border:var(\n    --product-card-image-border,\n    var(--product-card-image-border-default)\n  )}.image.responsive{width:100%;height:auto}.currency{padding-left:var(--spacing-50)}.brand,.title,.product-type{display:-webkit-box;max-width:var(--product-card-set-mode-max-width);text-align:var(\n    --product-card-text-align,\n    var(--product-card-text-align-default)\n  );-webkit-box-orient:vertical;-webkit-line-clamp:1;overflow-wrap:anywhere;text-overflow:ellipsis;overflow:hidden}.title{font-weight:var(--font-weight-600);color:var(--color-text-primary);-webkit-line-clamp:2}.deeplink{max-width:100%;text-decoration:none}.image-link{display:contents}picture{display:block;width:100%;height:100%;position:relative}picture::before{display:block;box-sizing:border-box;position:absolute;width:100%;height:100%;top:0;left:0;content:\"\";opacity:0}.update-button{position:absolute;width:32px;height:32px;top:var(--spacing-100);right:var(--spacing-100);z-index:1;background-color:var(--button-bg-color-frosted);color:var(--color-icon-on-color);-webkit-backdrop-filter:blur(calc(var(--filter-blur-150) / 2));backdrop-filter:blur(calc(var(--filter-blur-150) / 2));padding:var(--spacing-50);border:none;cursor:pointer}.update-button::after{position:absolute;width:calc(100% + var(--spacing-100));height:calc(100% + var(--spacing-100));top:calc(-1 * var(--spacing-50));right:calc(-1 * var(--spacing-50));content:\"\"}.update-button:hover{background-color:var(--button-bg-color-frosted-hover)}.basket-button{box-sizing:border-box;border:none;width:100%;padding:var(--spacing-100);font-size:var(--font-size-label);font-weight:var(--font-weight-600);font-family:var(--font-family, var(--font-family-base));color:var(--color-text-primary);background-color:var(--button-bg-color-secondary);cursor:pointer}.basket-button:hover{background-color:var(--button-bg-color-secondary-hover)}.basket-button-icon-container{display:inline-flex;align-items:center;justify-content:center}picture::after{box-sizing:border-box;display:block;position:absolute;width:100%;height:100%;top:0;left:0;background-color:var(\n    --product-card-image-bg-color,\n    var(--product-card-image-bg-color-default)\n  );mix-blend-mode:multiply;content:\"\"}:host(.animated) picture::after{mix-blend-mode:normal}:host(.animated) picture::before{opacity:1;animation:pulse 1.8s infinite}:host(.animated) picture::after{content:url(\"data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_810_154)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M64.7332 1.23333C66.2665 12.2667 67.9665 13.9667 78.6665 15.2333C79.4332 15.3333 79.9999 15.9333 79.9999 16.6667C79.9999 17.4 79.4665 17.9333 78.6665 18.0667C67.9665 19.3667 66.2999 21.0333 64.7332 32.0667C64.6332 32.8 64.0665 33.3333 63.3665 33.3333C62.6665 33.3333 62.0999 32.8 61.9665 32.0667C60.4665 21.0333 58.7665 19.3667 48.0332 18.0667C47.2332 17.9667 46.6999 17.4333 46.6999 16.6667C46.6999 15.9 47.2332 15.3667 48.0332 15.2333C58.7665 13.7667 60.3999 12.2 61.9665 1.23333C62.0999 0.5 62.6665 0 63.3665 0C64.0665 0 64.5999 0.5 64.7332 1.23333ZM38.5665 71.5667C38.3665 72.6 37.6665 73.3333 36.6665 73.3333C35.6665 73.3333 34.9665 72.6 34.7998 71.5667C31.9332 50.7 29.0998 47.9 8.49984 45.2C7.39984 45.1 6.6665 44.3 6.6665 43.3C6.6665 42.3 7.39984 41.5333 8.49984 41.4333C29.1332 39.1333 32.0998 35.9333 34.7998 15.0333C34.9665 14.0333 35.6665 13.3333 36.6665 13.3333C37.6665 13.3333 38.3665 14 38.5665 15.0333C41.2665 35.9333 44.1998 39.1333 64.8665 41.4333C65.9332 41.5333 66.6665 42.2667 66.6665 43.3C66.6665 44.3333 65.9332 45.1 64.8665 45.2C44.1998 47.5 41.2665 50.7 38.5665 71.5667Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_810_154'%3E%3Crect width='80' height='80' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\");position:absolute;width:80px;height:80px;left:calc(50% - 40px);top:calc(50% - 40px);background-color:transparent}:host(.animated) .update-button{display:none}.basket-button-content{box-sizing:border-box;display:flex;align-items:center;justify-content:center;gap:var(--spacing-75)}:host(.product-card--source){flex-grow:1}:host(.product-card--source) picture{aspect-ratio:1}picture .plus-icon{position:absolute;width:32px;height:32px;top:calc(50% - 32px);right:-88px;padding:var(--spacing-200);background-color:var(--color-bg-base);color:var(--color-text-placeholder);outline:1px solid var(--color-border-01);z-index:1;border-radius:50%}.basket-button.pressed{background-color:var(\n    --basket-button-bg-color-pressed,\n    var(--basket-button-bg-color-pressed-default)\n  )}.basket-button.pressed .discount-percentage{padding-right:var(--spacing-50)}@media (max-width: 768px){picture .plus-icon{padding:var(--spacing-100);top:calc(50% - var(--spacing-300));right:calc(-1 * var(--spacing-300))}}@keyframes pulse{0%{background-color:var(--surface-bg-color-01)}50%{background-color:var(--surface-bg-color-01-active)}100%{background-color:var(--surface-bg-color-01)}}.discount-label{position:absolute;left:var(--spacing-none);top:var(--spacing-150);padding:var(--spacing-25) var(--spacing-50);border-radius:var(--border-radius-none) var(--border-radius-50)\n    var(--border-radius-50) var(--border-radius-none);color:var(--color-text-on-color);background-color:var(--label-bg-color-accent);letter-spacing:var(--letter-spacing-label)}vviinn-energy-label{justify-content:var(\n    --product-card-content-align,\n    var(--product-card-content-align-default)\n  )}.product-card-actions,.product-card-top-actions{position:absolute;right:8px}.product-card-top-actions{top:8px}.product-card-actions{bottom:8px}.product-card-top-actions button{border:none;display:flex;padding:var(--spacing-50);justify-content:center;align-items:center;gap:var(--spacing-50);border-radius:var(--border-radius-100);background:var(--button-bg-color-frosted);-webkit-backdrop-filter:blur(calc(var(--filter-blur-150, 12px) / 2));backdrop-filter:blur(calc(var(--filter-blur-150, 12px) / 2));color:var(--color-icon-inverse);cursor:pointer;line-height:0px}.product-card-top-actions button:hover{background:var(--button-bg-color-frosted-hover)}::slotted([slot=\"vviinn-product-card-actions\"]),.product-card-top-actions{display:flex;flex-direction:column;gap:8px}.hidden{display:none !important}";

const VviinnProductCard = class {
  constructor(hostRef) {
    index.registerInstance(this, hostRef);
    this.vviinnProductLoad = index.createEvent(this, "vviinnProductLoad", 7);
    this.vviinnProductView = index.createEvent(this, "vviinnProductView", 7);
    this.vviinnProductClick = index.createEvent(this, "vviinnProductClick", 7);
    this.vviinnAddToBasket = index.createEvent(this, "vviinnAddToBasket", 7);
    this.vviinnFavorite = index.createEvent(this, "vviinnFavorite", 7);
    this.vviinnAuxClick = index.createEvent(this, "vviinnAuxClick", 7);
    this.vviinnCrossSellingClick = index.createEvent(this, "vviinnCrossSellingClick", 7);
    this.vviinnUpdatingAllCardsStarted = index.createEvent(this, "vviinnUpdatingAllCardsStarted", 7);
    this.vviinnUpdatingAllCardsFinished = index.createEvent(this, "vviinnUpdatingAllCardsFinished", 7);
    this.productData = null;
    this.isShowUpdateButton = () => this.setMode &&
      !this.isSourceProduct &&
      !this.basketButonPressed &&
      this.updateButtonLocation !== "onTop";
    this.isShowBasketButton = () => !this.isSourceProduct && (this.addToBasketShow || this.setMode);
    this.intersectionCallback = (data) => {
      if (!data.length)
        return;
      if (data.some((entry) => entry.isIntersecting)) {
        search_store._function.pipe(getAnalyticsModule, search_store.Option.map((analytics) => analytics.sendImpression(this.getProduct())));
        this.vviinnProductView.emit(this.productData);
        this.intersectionObserver.disconnect();
      }
    };
    this.brand = undefined;
    this.currency = undefined;
    this.image = undefined;
    this.imageRatio = 1;
    this.imageWidth = 200;
    this.locale = undefined;
    this.price = undefined;
    this.basePrice = undefined;
    this.pricePrefix = undefined;
    this.productTitle = undefined;
    this.productType = undefined;
    this.setMode = false;
    this.salePrice = undefined;
    this.baseSalePrice = undefined;
    this.responsive = false;
    this.addToBasketShow = undefined;
    this.favoriteShow = undefined;
    this.updateButtonLocation = undefined;
    this.customLabels = "";
    this.addPriceContainer = false;
    this.energyCertifications = undefined;
    this.productId = undefined;
    this.campaignTypeId = undefined;
    this.widgetElementId = undefined;
    this.buttonElementId = undefined;
    this.widgetVersion = undefined;
    this.deeplink = undefined;
    this.index = 0;
    this.updatingAllCards = undefined;
    this.defaultAnimationInterval = undefined;
    this.appliedDiscountPercentage = undefined;
    this.currentDiscountPercentage = undefined;
    this.isSourceProduct = false;
    this.isResultsWidget = false;
    this.energyCertificationsString = "";
    this.isStandalone = false;
    this.isTransitioning = false;
    this.basketButonPressed = false;
    this.favoriteButonPressed = false;
  }
  connectedCallback() {
    this.productData = this.getProductData();
    this.isStandalone &&
      index$2.instance.init({
        lng: this.locale,
        fallbackLng: "en",
        resources: index$2.resources,
      });
    if (this.energyCertificationsString.length > 0) {
      this.parseEnergyCertificationsString();
    }
  }
  componentWillLoad() {
    _package.slotChangeListener(this, this.el);
  }
  componentDidLoad() {
    this.vviinnProductLoad.emit(this.productData);
    this.intersectionObserver = new IntersectionObserver(this.intersectionCallback.bind(this.imageElement), { threshold: 1.0 });
    this.intersectionObserver.observe(this.imageElement);
    this.addLinksEventListeners();
  }
  crossSellingClickListener({ detail }) {
    const { animationInterval } = detail;
    this.isTransitioning = true;
    this.basketButonPressed = false;
    const animationTimer = setTimeout(() => {
      this.isTransitioning = false;
      clearTimeout(animationTimer);
    }, animationInterval);
  }
  updatingAllCardsWatcher() {
    if (!this.updatingAllCards)
      return;
    this.vviinnUpdatingAllCardsStarted.emit();
    this.isTransitioning = true;
    this.basketButonPressed = false;
    const animationTimer = setTimeout(() => {
      this.vviinnUpdatingAllCardsFinished.emit();
      this.isTransitioning = false;
      clearTimeout(animationTimer);
    }, this.defaultAnimationInterval);
  }
  productIdWatcher() {
    this.productData = this.getProductData();
  }
  parseEnergyCertificationsString() {
    if (this.energyCertificationsString === "")
      return;
    try {
      this.energyCertifications = JSON.parse(this.energyCertificationsString);
    }
    catch (e) {
      console.error("Invalid filters string", e);
    }
  }
  getWidgetType() {
    return this.campaignTypeId;
  }
  getProductData() {
    var _a;
    return {
      productId: this.productId,
      productRank: this.index,
      productName: this.productTitle,
      productType: this.productType,
      widgetType: this.getWidgetType(),
      campaignTypeId: this.campaignTypeId,
      campaignTypeName: _package.campaignTypeNames[this.campaignTypeId],
      widgetId: (_a = this.buttonElementId) !== null && _a !== void 0 ? _a : this.widgetElementId,
      widgetVersion: this.widgetVersion,
    };
  }
  basketButtonClickHandler() {
    this.vviinnAddToBasket.emit(Object.assign(Object.assign({}, this.productData), { discount: this.currentDiscountPercentage }));
    this.basketButonPressed = true;
  }
  favoriteButtonClickHandler() {
    this.vviinnFavorite.emit(Object.assign({}, this.productData));
    this.favoriteButonPressed = !this.favoriteButonPressed;
  }
  productClickHandler(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.vviinnProductClick.emit(Object.assign(Object.assign({}, this.productData), { clickEvent: event }));
    search_store._function.pipe(getAnalyticsModule, search_store.Option.match(() => null, (analytics) => analytics.sendClick(this.getProduct())));
  }
  addLinksEventListeners() {
    const links = this.el.shadowRoot.querySelectorAll("a");
    links.forEach((link) => {
      link.addEventListener("click", this.productClickHandler.bind(this));
      link.addEventListener("auxclick", () => {
        this.vviinnAuxClick.emit(Object.assign({}, this.productData));
      });
    });
  }
  getProduct() {
    return search_store.searchState.results.find((r) => r.productId === this.productId);
  }
  renderImage() {
    const props = {
      width: this.imageWidth,
      height: this.imageWidth * this.imageRatio,
      src: this.image,
      title: this.productTitle,
      lazy: false,
      ref: (el) => {
        this.imageElement = el;
      },
      isSource: this.isSourceProduct,
    };
    return this.responsive ? ResponsiveImage(props) : Image(props);
  }
  render() {
    var _a, _b, _c;
    return (index.h(index.Host, { part: "product-card", class: {
        animated: this.isTransitioning,
      }, exportparts: "image-container, content-container, basket-button-container, brand, product-type, custom-label-0, custom-label-1, custom-label-2, custom-label-3, custom-label-4, currency, deeplink, image, image-link, image-picture, price-container, price-amount-regular, price-amount-sale, price-amount-outdated, price-amount-base-regular, price-amount-base-sale, price-amount-base-outdated, price-outdated, price-regular, price-sale, price-prefix, discount-label, discount-percentage, title, basket-button, update-button-item, energy-label-container, energy-label-icon, energy-label-product-type, energy-label-data-sheet-link, product-card-actions, product-card-top-actions" }, index.h("div", { class: "image-container", part: "image-container" }, index.h(Linked, { deeplink: this.deeplink, part: "image-link" }, this.renderImage()), index.h("div", { class: "product-card-top-actions", part: "product-card-top-actions" }, index.h("button", { class: {
        hidden: !this.favoriteShow,
      }, part: "favorite-button", onClick: this.favoriteButtonClickHandler.bind(this) }, index.h("div", { key: "favorite-not-pressed", class: {
        hidden: this.favoriteButonPressed,
      } }, index.h("slot", { name: "vviinn-favorite-icon" }, index.h(FavoriteIcon, null))), index.h("div", { key: "favorite-pressed", class: {
        hidden: !this.favoriteButonPressed,
      } }, index.h("slot", { name: "vviinn-favorite-icon-pressed" }, index.h(FavoriteIconPressed, null))))), index.h("div", { class: "product-card-actions", part: "product-card-actions" }, index.h("slot", { name: "vviinn-product-card-actions" }))), index.h("div", { class: "content-container", part: "content-container" }, this.isTransitioning ? (index.h(index.Fragment, null, index.h("vviinn-skeleton", { height: 40 }), index.h("vviinn-skeleton", { height: 20, halfWidth: true }))) : (index.h(index.Fragment, null, index.h(Linked, { deeplink: this.deeplink, part: "deeplink" }, index.h("span", { class: "title", part: "title" }, this.productTitle)), ((_a = this.brand) === null || _a === void 0 ? void 0 : _a.length) > 0 && (index.h("span", { class: "brand", part: "brand" }, this.brand)), ((_b = this.productType) === null || _b === void 0 ? void 0 : _b.length) > 0 && (index.h("span", { class: "product-type", part: "product-type" }, this.productType)), ((_c = this === null || this === void 0 ? void 0 : this.energyCertifications) !== null && _c !== void 0 ? _c : []).map((energyCertification) => (index.h("vviinn-energy-label", { classIconUrls: energyCertification === null || energyCertification === void 0 ? void 0 : energyCertification.classIconUrls, classDataSheetUrl: energyCertification === null || energyCertification === void 0 ? void 0 : energyCertification.classDataSheetUrl, productType: energyCertification === null || energyCertification === void 0 ? void 0 : energyCertification.productType }))), index.h(Price, { prefix: this.pricePrefix, currency: this.currency, price: this.price, basePrice: parseBasePrice(this.basePrice), salePrice: this.salePrice, baseSalePrice: parseBasePrice(this.baseSalePrice), locale: this.locale, showInContainer: this.addPriceContainer }), this.setMode &&
      !this.appliedDiscountPercentage &&
      this.currentDiscountPercentage && (index.h("div", { class: "discount-label", part: "discount-label" }, `-${this.currentDiscountPercentage}%`)))), renderCustomLabels(this.customLabels.split(",")), index.h("vviinn-skeleton", { height: 40, class: {
        hidden: !this.isTransitioning,
      } })), index.h("div", { class: {
        "basket-button-container": true,
        hidden: !this.isShowBasketButton(),
      }, part: "basket-button-container" }, index.h("button", { class: {
        "basket-button": true,
        hidden: this.isTransitioning,
        pressed: this.basketButonPressed,
      }, part: "basket-button", onClick: this.basketButtonClickHandler.bind(this) }, index.h("div", { class: {
        "basket-button-content": true,
        hidden: this.basketButonPressed,
      }, key: "not-pressed" }, index.h("span", { class: "basket-button-icon-container" }, index.h("slot", { name: "vviinn-basket-button-icon" }, index.h(BasketIcon, null))), index.h("span", null, this.setMode ? (index.h("slot", { name: "vviinn-basket-button-text", key: "button-text-set" }, index$2.instance.t("setMode.basketButtonText"))) : (index.h("slot", { name: "vviinn-basket-button-text", key: "button-text-default" }, index$2.instance.t("basketButtonText"))))), index.h("div", { key: "pressed", class: {
        "basket-button-content": true,
        hidden: !this.basketButonPressed,
      } }, index.h("span", { class: "basket-button-icon-container" }, index.h("slot", { name: "vviinn-basket-button-icon-pressed" }, index.h(CheckCircleIcon, null))), index.h("span", null, index.h("span", { class: "discount-percentage", part: "discount-percentage", hidden: !(this.setMode && this.appliedDiscountPercentage) }, this.appliedDiscountPercentage, "%"), index.h("slot", { name: "vviinn-basket-button-text-pressed" }, this.setMode
      ? index$2.instance.t("setMode.basketButtonPressedText")
      : index$2.instance.t("basketButtonPressedText")))))), index.h("button", { class: {
        "update-button": true,
        hidden: !this.isShowUpdateButton(),
      }, part: "update-button-item", onClick: () => {
        this.vviinnCrossSellingClick.emit({
          animationInterval: generateRandomNumber(800, 1400),
          productData: this.productData,
        });
      } }, index.h("slot", { name: "vviinn-update-button-icon" }, index.h(UpdateIcon, null)))));
  }
  get el() { return index.getElement(this); }
  static get watchers() { return {
    "updatingAllCards": ["updatingAllCardsWatcher"],
    "productId": ["productIdWatcher"]
  }; }
};
VviinnProductCard.style = vviinnProductCardCss;

const vviinnSkeletonCss = ":host{display:block;width:100%;height:100%;line-height:0}.vviinn-skeleton{display:inline-block;animation:pulse 1.2s infinite}@keyframes pulse{0%{background-color:rgb(244, 244, 244)}50%{background-color:rgb(232, 232, 232)}100%{background-color:rgba(244, 244, 244)}}";

const VviinnSkeleton = class {
  constructor(hostRef) {
    index.registerInstance(this, hostRef);
    this.height = undefined;
    this.halfWidth = false;
  }
  render() {
    return (index.h(index.Host, null, index.h("div", { class: {
        "vviinn-skeleton": true,
      }, style: {
        height: `${this.height.toString()}px`,
        width: this.halfWidth ? "50%" : "100%",
      } })));
  }
  get el() { return index.getElement(this); }
};
VviinnSkeleton.style = vviinnSkeletonCss;

function isFunction(value) {
    return typeof value === 'function';
}

function createErrorClass(createImpl) {
    const _super = (instance) => {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    const ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

const UnsubscriptionError = createErrorClass((_super) => function UnsubscriptionErrorImpl(errors) {
    _super(this);
    this.message = errors
        ? `${errors.length} errors occurred during unsubscription:
${errors.map((err, i) => `${i + 1}) ${err.toString()}`).join('\n  ')}`
        : '';
    this.name = 'UnsubscriptionError';
    this.errors = errors;
});

function arrRemove(arr, item) {
    if (arr) {
        const index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

class Subscription {
    constructor(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    unsubscribe() {
        let errors;
        if (!this.closed) {
            this.closed = true;
            const { _parentage } = this;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) {
                    for (const parent of _parentage) {
                        parent.remove(this);
                    }
                }
                else {
                    _parentage.remove(this);
                }
            }
            const { initialTeardown: initialFinalizer } = this;
            if (isFunction(initialFinalizer)) {
                try {
                    initialFinalizer();
                }
                catch (e) {
                    errors = e instanceof UnsubscriptionError ? e.errors : [e];
                }
            }
            const { _finalizers } = this;
            if (_finalizers) {
                this._finalizers = null;
                for (const finalizer of _finalizers) {
                    try {
                        execFinalizer(finalizer);
                    }
                    catch (err) {
                        errors = errors !== null && errors !== void 0 ? errors : [];
                        if (err instanceof UnsubscriptionError) {
                            errors = [...errors, ...err.errors];
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
            if (errors) {
                throw new UnsubscriptionError(errors);
            }
        }
    }
    add(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) {
                execFinalizer(teardown);
            }
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) {
                        return;
                    }
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    }
    _hasParent(parent) {
        const { _parentage } = this;
        return _parentage === parent || (Array.isArray(_parentage) && _parentage.includes(parent));
    }
    _addParent(parent) {
        const { _parentage } = this;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
    }
    _removeParent(parent) {
        const { _parentage } = this;
        if (_parentage === parent) {
            this._parentage = null;
        }
        else if (Array.isArray(_parentage)) {
            arrRemove(_parentage, parent);
        }
    }
    remove(teardown) {
        const { _finalizers } = this;
        _finalizers && arrRemove(_finalizers, teardown);
        if (teardown instanceof Subscription) {
            teardown._removeParent(this);
        }
    }
}
Subscription.EMPTY = (() => {
    const empty = new Subscription();
    empty.closed = true;
    return empty;
})();
const EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value) {
    return (value instanceof Subscription ||
        (value && 'closed' in value && isFunction(value.remove) && isFunction(value.add) && isFunction(value.unsubscribe)));
}
function execFinalizer(finalizer) {
    if (isFunction(finalizer)) {
        finalizer();
    }
    else {
        finalizer.unsubscribe();
    }
}

const config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false,
};

const timeoutProvider = {
    setTimeout(handler, timeout, ...args) {
        const { delegate } = timeoutProvider;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) {
            return delegate.setTimeout(handler, timeout, ...args);
        }
        return setTimeout(handler, timeout, ...args);
    },
    clearTimeout(handle) {
        const { delegate } = timeoutProvider;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined,
};

function reportUnhandledError(err) {
    timeoutProvider.setTimeout(() => {
        const { onUnhandledError } = config;
        if (onUnhandledError) {
            onUnhandledError(err);
        }
        else {
            throw err;
        }
    });
}

function noop() { }

const COMPLETE_NOTIFICATION = (() => createNotification('C', undefined, undefined))();
function errorNotification(error) {
    return createNotification('E', undefined, error);
}
function nextNotification(value) {
    return createNotification('N', value, undefined);
}
function createNotification(kind, value, error) {
    return {
        kind,
        value,
        error,
    };
}

function errorContext(cb) {
    {
        cb();
    }
}

class Subscriber extends Subscription {
    constructor(destination) {
        super();
        this.isStopped = false;
        if (destination) {
            this.destination = destination;
            if (isSubscription(destination)) {
                destination.add(this);
            }
        }
        else {
            this.destination = EMPTY_OBSERVER;
        }
    }
    static create(next, error, complete) {
        return new SafeSubscriber(next, error, complete);
    }
    next(value) {
        if (this.isStopped) {
            handleStoppedNotification(nextNotification(value), this);
        }
        else {
            this._next(value);
        }
    }
    error(err) {
        if (this.isStopped) {
            handleStoppedNotification(errorNotification(err), this);
        }
        else {
            this.isStopped = true;
            this._error(err);
        }
    }
    complete() {
        if (this.isStopped) {
            handleStoppedNotification(COMPLETE_NOTIFICATION, this);
        }
        else {
            this.isStopped = true;
            this._complete();
        }
    }
    unsubscribe() {
        if (!this.closed) {
            this.isStopped = true;
            super.unsubscribe();
            this.destination = null;
        }
    }
    _next(value) {
        this.destination.next(value);
    }
    _error(err) {
        try {
            this.destination.error(err);
        }
        finally {
            this.unsubscribe();
        }
    }
    _complete() {
        try {
            this.destination.complete();
        }
        finally {
            this.unsubscribe();
        }
    }
}
const _bind = Function.prototype.bind;
function bind(fn, thisArg) {
    return _bind.call(fn, thisArg);
}
class ConsumerObserver {
    constructor(partialObserver) {
        this.partialObserver = partialObserver;
    }
    next(value) {
        const { partialObserver } = this;
        if (partialObserver.next) {
            try {
                partialObserver.next(value);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    }
    error(err) {
        const { partialObserver } = this;
        if (partialObserver.error) {
            try {
                partialObserver.error(err);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
        else {
            handleUnhandledError(err);
        }
    }
    complete() {
        const { partialObserver } = this;
        if (partialObserver.complete) {
            try {
                partialObserver.complete();
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    }
}
class SafeSubscriber extends Subscriber {
    constructor(observerOrNext, error, complete) {
        super();
        let partialObserver;
        if (isFunction(observerOrNext) || !observerOrNext) {
            partialObserver = {
                next: (observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined),
                error: error !== null && error !== void 0 ? error : undefined,
                complete: complete !== null && complete !== void 0 ? complete : undefined,
            };
        }
        else {
            let context;
            if (this && config.useDeprecatedNextContext) {
                context = Object.create(observerOrNext);
                context.unsubscribe = () => this.unsubscribe();
                partialObserver = {
                    next: observerOrNext.next && bind(observerOrNext.next, context),
                    error: observerOrNext.error && bind(observerOrNext.error, context),
                    complete: observerOrNext.complete && bind(observerOrNext.complete, context),
                };
            }
            else {
                partialObserver = observerOrNext;
            }
        }
        this.destination = new ConsumerObserver(partialObserver);
    }
}
function handleUnhandledError(error) {
    {
        reportUnhandledError(error);
    }
}
function defaultErrorHandler(err) {
    throw err;
}
function handleStoppedNotification(notification, subscriber) {
    const { onStoppedNotification } = config;
    onStoppedNotification && timeoutProvider.setTimeout(() => onStoppedNotification(notification, subscriber));
}
const EMPTY_OBSERVER = {
    closed: true,
    next: noop,
    error: defaultErrorHandler,
    complete: noop,
};

const observable = (() => (typeof Symbol === 'function' && Symbol.observable) || '@@observable')();

function identity(x) {
    return x;
}

function pipeFromArray(fns) {
    if (fns.length === 0) {
        return identity;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce((prev, fn) => fn(prev), input);
    };
}

class Observable {
    constructor(subscribe) {
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    lift(operator) {
        const observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    }
    subscribe(observerOrNext, error, complete) {
        const subscriber = isSubscriber(observerOrNext) ? observerOrNext : new SafeSubscriber(observerOrNext, error, complete);
        errorContext(() => {
            const { operator, source } = this;
            subscriber.add(operator
                ?
                    operator.call(subscriber, source)
                : source
                    ?
                        this._subscribe(subscriber)
                    :
                        this._trySubscribe(subscriber));
        });
        return subscriber;
    }
    _trySubscribe(sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.error(err);
        }
    }
    forEach(next, promiseCtor) {
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor((resolve, reject) => {
            const subscriber = new SafeSubscriber({
                next: (value) => {
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve,
            });
            this.subscribe(subscriber);
        });
    }
    _subscribe(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    }
    [observable]() {
        return this;
    }
    pipe(...operations) {
        return pipeFromArray(operations)(this);
    }
    toPromise(promiseCtor) {
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor((resolve, reject) => {
            let value;
            this.subscribe((x) => (value = x), (err) => reject(err), () => resolve(value));
        });
    }
}
Observable.create = (subscribe) => {
    return new Observable(subscribe);
};
function getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config.Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
    return value && isFunction(value.next) && isFunction(value.error) && isFunction(value.complete);
}
function isSubscriber(value) {
    return (value && value instanceof Subscriber) || (isObserver(value) && isSubscription(value));
}

const ObjectUnsubscribedError = createErrorClass((_super) => function ObjectUnsubscribedErrorImpl() {
    _super(this);
    this.name = 'ObjectUnsubscribedError';
    this.message = 'object unsubscribed';
});

class Subject extends Observable {
    constructor() {
        super();
        this.closed = false;
        this.currentObservers = null;
        this.observers = [];
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    lift(operator) {
        const subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    }
    _throwIfClosed() {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
    }
    next(value) {
        errorContext(() => {
            this._throwIfClosed();
            if (!this.isStopped) {
                if (!this.currentObservers) {
                    this.currentObservers = Array.from(this.observers);
                }
                for (const observer of this.currentObservers) {
                    observer.next(value);
                }
            }
        });
    }
    error(err) {
        errorContext(() => {
            this._throwIfClosed();
            if (!this.isStopped) {
                this.hasError = this.isStopped = true;
                this.thrownError = err;
                const { observers } = this;
                while (observers.length) {
                    observers.shift().error(err);
                }
            }
        });
    }
    complete() {
        errorContext(() => {
            this._throwIfClosed();
            if (!this.isStopped) {
                this.isStopped = true;
                const { observers } = this;
                while (observers.length) {
                    observers.shift().complete();
                }
            }
        });
    }
    unsubscribe() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    }
    get observed() {
        var _a;
        return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
    }
    _trySubscribe(subscriber) {
        this._throwIfClosed();
        return super._trySubscribe(subscriber);
    }
    _subscribe(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    }
    _innerSubscribe(subscriber) {
        const { hasError, isStopped, observers } = this;
        if (hasError || isStopped) {
            return EMPTY_SUBSCRIPTION;
        }
        this.currentObservers = null;
        observers.push(subscriber);
        return new Subscription(() => {
            this.currentObservers = null;
            arrRemove(observers, subscriber);
        });
    }
    _checkFinalizedStatuses(subscriber) {
        const { hasError, thrownError, isStopped } = this;
        if (hasError) {
            subscriber.error(thrownError);
        }
        else if (isStopped) {
            subscriber.complete();
        }
    }
    asObservable() {
        const observable = new Observable();
        observable.source = this;
        return observable;
    }
}
Subject.create = (destination, source) => {
    return new AnonymousSubject(destination, source);
};
class AnonymousSubject extends Subject {
    constructor(destination, source) {
        super();
        this.destination = destination;
        this.source = source;
    }
    next(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value);
    }
    error(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
    }
    complete() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    _subscribe(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : EMPTY_SUBSCRIPTION;
    }
}

const createBearerString = (x) => `Bearer ${x}`;
const createAuthedHeader = (x) => new Headers({
  Authorization: x,
  "Content-Type": "application/json",
});
const createFetchAuthOptions = (x) => {
  return {
    headers: x,
  };
};
const createBearAuthedHeader = search_store._function.flow(createBearerString, createAuthedHeader, createFetchAuthOptions);

const sequenceToEither = sequenceT(search_store.Apply);
const apiPost = (path, data = {}) => search_store.pipe(sequenceToEither(search_store.getApiPath(), search_store.createInitPostRequest), search_store.fromEither, search_store.chainW(search_store.makeRequest(path, data)));

const getVPRRecommendations = (body) => (options) => {
  const url = "similar-products";
  return apiPost(url, Object.assign(Object.assign({}, options), { body: JSON.stringify(body) }));
};

const getVCSRecommendations = (body) => (options) => {
  const url = "cross-selling";
  return apiPost(url, Object.assign(Object.assign({}, options), { body: JSON.stringify(body) }));
};

const getRecommendationsService = (campaignType) => search_store._function.pipe(_package.fromString(campaignType), _package.fold(() => getVPRRecommendations, () => getVCSRecommendations));

const vviinnVprWidgetCss = ":host{--font-family-base:Inter, system-ui, sans-serif;--font-family-mono:monospace;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;--font-size-title:24px;--font-size-headline:18px;--font-size-label-large:16px;--font-size-label:14px;--font-size-body-large:16px;--font-size-body:14px;--font-size-caption:12px;--line-height-title:32px;--line-height-headline:24px;--line-height-label-large:24px;--line-height-label:20px;--line-height-body-large:24px;--line-height-body:20px;--line-height-caption:16px;--letter-spacing-title:0px;--letter-spacing-headline:0px;--letter-spacing-label-large:0px;--letter-spacing-label:0px;--letter-spacing-body-large:0px;--letter-spacing-body:0px;--letter-spacing-caption:0px;--font-weight-400:400;--font-weight-500:500;--font-weight-600:600;--font-weight-700:700;--spacing-none:0px;--spacing-25:2px;--spacing-50:4px;--spacing-75:6px;--spacing-100:8px;--spacing-125:10px;--spacing-150:12px;--spacing-200:16px;--spacing-250:20px;--spacing-300:24px;--spacing-400:32px;--spacing-500:40px;--spacing-600:48px;--border-radius-none:0px;--border-radius-25:2px;--border-radius-50:4px;--border-radius-100:8px;--border-radius-150:12px;--border-radius-200:16px;--border-radius-300:24px;--border-radius-400:32px;--border-radius-full:9999px;--stroke-width-none:0px;--stroke-width-25:1px;--stroke-width-50:2px;--stroke-width-75:3px;--stroke-width-100:4px;--stroke-width-150:6px;--stroke-width-200:8px;--stroke-width-300:12px;--product-card-widget-min-width:135px;--product-card-results-min-width:250px;--image-set-mode-min-size:155px;--product-card-set-mode-max-width:300px;--source-card-set-mode-max-width:500px;--filter-blur-none:0px;--filter-blur-100:8px;--filter-blur-150:12px;--filter-blur-200:16px;--color-bg-base:#ffffff;--color-bg-inverse:#161616;--color-border-00:#ffffff;--color-border-01:#f4f4f4;--color-border-02:#e0e0e0;--color-border-03:#c6c6c6;--color-border-inverse-00:#161616;--color-border-inverse-01:#393939;--color-field-01:#ffffff;--color-field-02:#f4f4f4;--color-icon-primary:#161616;--color-icon-secondary:#525252;--color-icon-helper:#8d8d8d;--color-icon-on-color:#ffffff;--color-icon-inverse:#ffffff;--color-icon-disabled:#16161640;--color-text-primary:#161616;--color-text-secondary:#525252;--color-text-helper:#8d8d8d;--color-text-placeholder:#a8a8a8;--color-text-on-color:#ffffff;--color-text-inverse:#ffffff;--color-text-disabled:#16161640;--button-bg-color-primary:#000000;--button-bg-color-primary-hover:#161616;--button-bg-color-primary-active:#1e1e1e;--button-bg-color-secondary:#f4f4f4;--button-bg-color-secondary-hover:#e0e0e0;--button-bg-color-secondary-active:#c6c6c6;--button-bg-color-ghost-hover:#f4f4f4;--button-bg-color-ghost-active:#eaeaea;--button-bg-color-frosted:#6f6f6f66;--button-bg-color-frosted-hover:#6f6f6f80;--button-bg-color-frosted-active:#6f6f6f99;--button-bg-color-disabled:#e0e0e0;--button-bg-color-positive:#dcfce7;--surface-bg-color-01:#f4f4f4;--surface-bg-color-01-hover:#eaeaea;--surface-bg-color-01-active:#e0e0e0;--surface-bg-color-02:#ffffff;--surface-bg-color-inverse:#262626;--surface-bg-color-inverse-hover:#303030;--surface-bg-color-inverse-active:#393939;--surface-bg-color-disabled:#e0e0e0;--chip-bg-color-primary:#161616;--chip-bg-color-primary-hover:#1e1e1e;--chip-bg-color-primary-active:#262626;--chip-bg-color-subtle:#f4f4f4;--chip-bg-color-subtle-hover:#eaeaea;--chip-bg-color-subtle-active:#e0e0e0;--chip-bg-color-outline-hover:#f4f4f4;--chip-bg-color-outline-active:#eaeaea;--label-bg-color-accent:#ff3944;}:host{display:grid;grid-gap:var(--spacing-200);width:100%}:host(:not(.loaded)){position:absolute;visibility:hidden}:host(.set){grid-gap:var(--spacing-300)}:host(.set) vviinn-carousel{overflow-x:auto;scrollbar-width:thin}:host(.set) vviinn-product-card::part(image){width:var(--vviinn-set-mode-image-width, 100%);height:auto;min-width:var(--image-set-mode-min-size);min-height:var(--image-set-mode-min-size)}:host(.set) vviinn-product-card.product-card--source::part(image){width:100%;height:auto}:host(.grid) h2{justify-content:center}.filters-header{display:flex;justify-content:space-between;gap:14px}.filters-header>vviinn-extended-filters{width:44px;height:44px}@media (max-width: 768px){.filters-header>vviinn-filters{flex:1;width:100px}}.widget-header{display:flex;flex-wrap:wrap;gap:20px;justify-content:space-between;align-items:center}.widget-header h3{margin-top:8px;margin-bottom:0;font-size:14px;font-weight:400;line-height:20px}.widget-header h2,.widget-header h3{margin:0;font-family:var(--font-family, var(--font-family-base))}.widget-header h2{font-weight:var(--font-weight-600);line-height:var(--line-height-title)}.widget-header h3{line-height:var(--line-height-body);margin-top:var(--spacing-100)}.update-button{display:flex;align-items:center;justify-content:center;font-family:var(--font-family, var(--font-family-base));color:#525252;gap:8px;padding:8px 10px;background:rgb(244, 244, 244);border:none;cursor:pointer}.update-button:hover{background:rgb(234, 234, 234)}.update-button svg{color:#6f6f6f}.results{display:grid;grid-gap:1rem}.no-result-text{font-family:var(--font-family, var(--font-family-base));font-size:20px}.visually-hidden{position:absolute;top:0;left:0;z-index:-1;height:0;width:0}";

var __rest = (undefined && undefined.__rest) || function (s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
};
const VviinnVprWidget = class {
  constructor(hostRef) {
    index.registerInstance(this, hostRef);
    this.vviinnWidgetLoad = index.createEvent(this, "vviinnWidgetLoad", 7);
    this.vviinnProductLoad = index.createEvent(this, "vviinnProductLoad", 7);
    this.vviinnProductView = index.createEvent(this, "vviinnProductView", 7);
    this.vviinnProductClick = index.createEvent(this, "vviinnProductClick", 7);
    this.vviinnResultLoad = index.createEvent(this, "vviinnResultLoad", 7);
    this.vviinnResultView = index.createEvent(this, "vviinnResultView", 7);
    this.vviinnNoResult = index.createEvent(this, "vviinnNoResult", 7);
    this.vviinnAddToBasket = index.createEvent(this, "vviinnAddToBasket", 7);
    this.vviinnFiltersChanged = index.createEvent(this, "vviinnFiltersChanged", 7);
    this.globalSlotsChanged = index.createEvent(this, "globalSlotsChanged", 7);
    this.vviinnRecommendationsLoaded = index.createEvent(this, "vviinnRecommendationsLoaded", 7);
    this.vviinnWidgetOpen = index.createEvent(this, "vviinnWidgetOpen", 7);
    this.vviinnWidgetClose = index.createEvent(this, "vviinnWidgetClose", 7);
    this.productImageLoadedSubject = new Subject();
    this.resultViewed = false;
    this.requestDynamicFilters = [];
    this.setTrackingDeactivated = (result) => {
      if (result.status === "rejected") {
        this.trackingDeactivated = true;
      }
    };
    this.token = undefined;
    this.productId = undefined;
    this.mode = "continuity";
    this.campaigns = "";
    this.excluded = "";
    this.campaignType = this.mode === "set" ? "VCS" : "VPR";
    this.locale = "de-DE";
    this.color = "";
    this.imageWidth = 300;
    this.imageRatio = 1;
    this.cssUrl = null;
    this.currencySign = "€";
    this.pricePrefix = "";
    this.noResultText = "";
    this.noResultShow = true;
    this.gridArrowsDynamic = false;
    this.productDetailsNewTab = false;
    this.productDetailsRedirect = true;
    this.addToBasketShow = false;
    this.showFilters = false;
    this.showExtendedFilters = false;
    this.setModeDiscounts = this.mode === "set" ? "5, 10, 15" : "";
    this.updateButtonLocation = "topAndItem";
    this.addPriceContainer = false;
    this.favoriteShow = false;
    this.blockTitle = "Recommended products";
    this.showScroll = true;
    this.apiPath = "https://api.vviinn.com";
    this.useCarousel = true;
    this.showingInButton = false;
    this.buttonElementId = undefined;
    this.closed = undefined;
    this.opened = undefined;
    this.recommendations = [];
    this.dynamicFilters = [];
    this.sourceProduct = null;
    this.trackingDeactivated = false;
    this.hasErrorOnLoad = false;
    this.updatingAllCards = false;
    this.updatedCardsAmount = 0;
    this.setModeDiscountsArray = [];
  }
  getBasicEventData() {
    return {
      widgetType: "VPR",
      campaignTypeId: this.campaignType,
      campaignTypeName: _package.campaignTypeNames[this.campaignType],
      widgetId: this.id,
      widgetVersion: _package.version,
    };
  }
  handleOpenLink(deeplink, event) {
    if (!this.productDetailsRedirect)
      return;
    if (this.productDetailsNewTab || event.ctrlKey || event.metaKey) {
      let newTab = window.open();
      if (newTab) {
        newTab.location.href = deeplink;
      }
      else {
        window.location.href = deeplink;
      }
    }
    else {
      window.location.href = deeplink;
    }
  }
  findProductById(id) {
    return this.recommendations.find((r) => r.productId === id);
  }
  replaceSlotsContent() {
    const slots = this.el.querySelectorAll("[slot]");
    this.globalSlotsChanged.emit({
      slots: Array.from(slots),
      element: this.el,
    });
  }
  handleProductIdChange() {
    this.getRecommendations();
  }
  handleCampaignTypeChange() {
    this.getRecommendations();
  }
  handleCampaignsChange() {
    this.getRecommendations();
  }
  handleApiPathChange(newPath) {
    search_store.state.apiPath = newPath;
    this.getRecommendations();
  }
  trackWidgetOpen() {
    if (!this.opened)
      return;
    this.vviinnWidgetOpen.emit(this.getBasicEventData());
    this.trackWidgetEvent("open");
  }
  trackWidgetClose() {
    if (!this.closed)
      return;
    this.vviinnWidgetClose.emit(this.getBasicEventData());
    this.trackWidgetEvent("close");
  }
  componentDidRender() {
    if (this.showingInButton && this.closed)
      return;
    this.replaceSlotsContent();
  }
  connectedCallback() {
    var _a;
    search_store.state.apiPath = this.apiPath;
    search_store.state.pricePrefix = this.pricePrefix;
    search_store.state.currencySign = this.currencySign;
    search_store.state.locale = this.locale;
    this.id = (_a = this.buttonElementId) !== null && _a !== void 0 ? _a : this.el.id;
    this.uiSessionId = index$2.v4();
    this.trackingApi = index$2.createTrackingApi(this.apiPath, this.token);
    this.getRecommendations();
    this.vviinnWidgetLoad.emit(this.getBasicEventData());
    this.trackWidgetEvent("load");
    this.isSetMode = this.mode === "set";
    this.isGridMode = this.mode === "grid";
    if (this.isSetMode && this.setModeDiscounts.length) {
      this.setModeDiscountsArray = this.setModeDiscounts
        .split(",")
        .map((d) => parseInt(d.trim()))
        .filter((d) => !isNaN(d));
    }
  }
  async componentWillLoad() {
    await index$2.instance.init({
      lng: this.locale,
      fallbackLng: "en",
      resources: index$2.resources,
    });
    _package.slotChangeListener(this, this.el);
  }
  trackProductLoad({ detail }) {
    this.productImageLoadedSubject.next(detail.productId);
    const productLoadEvent = this.getProductTrackEvent(detail, "load");
    if (!productLoadEvent)
      return;
    this.trackingApi
      .trackEvent(productLoadEvent)
      .then(this.setTrackingDeactivated);
  }
  trackProductView({ detail }) {
    if (!this.resultViewed) {
      this.resultViewed = true;
      this.vviinnResultView.emit(this.getBasicEventData());
      this.trackResultEvent("view");
    }
    const productViewEvent = this.getProductTrackEvent(detail, "view");
    if (!productViewEvent)
      return;
    this.trackingApi
      .trackEvent(productViewEvent)
      .then(this.setTrackingDeactivated);
  }
  async trackProductClick({ detail }) {
    const { productId, clickEvent } = detail;
    const product = this.findProductById(productId);
    if (!product || !product.deeplink)
      return;
    const productClickEvent = this.getProductTrackEvent(detail, "click");
    if (!this.trackingDeactivated) {
      await this.trackingApi
        .trackEvent(productClickEvent)
        .then(this.setTrackingDeactivated)
        .finally(() => {
        this.handleOpenLink(product.deeplink, clickEvent);
      });
    }
    else {
      this.handleOpenLink(product.deeplink, clickEvent);
    }
  }
  async trackAuxClick({ detail }) {
    const { productId } = detail;
    const product = this.findProductById(productId);
    if (!product || !product.deeplink)
      return;
    const productClickEvent = this.getProductTrackEvent(detail, "click");
    if (!this.trackingDeactivated) {
      await this.trackingApi
        .trackEvent(productClickEvent)
        .then(this.setTrackingDeactivated);
    }
  }
  async trackAddToBasket({ detail }) {
    const { productRank, productId, campaignTypeId, widgetType } = detail, rest = __rest(detail, ["productRank", "productId", "campaignTypeId", "widgetType"]);
    let addToBasketEvent;
    const eventBody = Object.assign({ session_id: this.uiSessionId, rank: productRank, product: productId }, rest);
    if (this.campaignType === "VCS") {
      addToBasketEvent = index$2.createAddToBasketVpcEvent(eventBody);
    }
    else if (this.campaignType === "VPR") {
      addToBasketEvent = index$2.createAddToBasketVprEvent(eventBody);
    }
    this.trackingApi
      .trackEvent(addToBasketEvent)
      .then(this.setTrackingDeactivated);
  }
  updatingAllCardsFinishedListener() {
    if (!this.updatingAllCards)
      return;
    this.updatingAllCards = false;
  }
  async filtersChanged({ detail }) {
    this.requestDynamicFilters = detail.filters;
    this.getRecommendations();
  }
  trackWidgetEvent(action) {
    if (this.trackingDeactivated)
      return;
    const _a = this.getBasicEventData(), rest = __rest(_a, ["campaignTypeId", "widgetType"]);
    let widgetEvent;
    const eventBody = Object.assign({ action, session_id: this.uiSessionId }, rest);
    if (this.campaignType === "VCS") {
      widgetEvent = index$2.createWidgetVpcEvent(eventBody);
    }
    else if (this.campaignType === "VPR") {
      widgetEvent = index$2.createWidgetVprEvent(eventBody);
    }
    this.trackingApi.trackEvent(widgetEvent).then(this.setTrackingDeactivated);
  }
  trackResultEvent(type) {
    if (this.trackingDeactivated)
      return;
    const _a = this.getBasicEventData(), rest = __rest(_a, ["campaignTypeId", "widgetType"]);
    let resultEvent;
    const eventBody = Object.assign({ session_id: this.uiSessionId }, rest);
    if (this.campaignType === "VCS") {
      resultEvent = index$2.createResultVpcEventByType(type)(eventBody);
    }
    else if (this.campaignType === "VPR") {
      resultEvent = index$2.createResultVprEventByType(type)(eventBody);
    }
    this.trackingApi.trackEvent(resultEvent).then(this.setTrackingDeactivated);
  }
  getProductTrackEvent(detail, eventType) {
    if (this.trackingDeactivated)
      return null;
    const { productRank, productId, campaignTypeId, widgetType, clickEvent } = detail, rest = __rest(detail, ["productRank", "productId", "campaignTypeId", "widgetType", "clickEvent"]);
    let productEvent;
    const eventBody = Object.assign({ session_id: this.uiSessionId, rank: productRank, product: productId }, rest);
    if (campaignTypeId === "VCS") {
      productEvent = index$2.createProductVpcEventByType(eventType)(eventBody);
    }
    else if (campaignTypeId === "VPR") {
      productEvent = index$2.createProductVprEventByType(eventType)(eventBody);
    }
    return productEvent;
  }
  async getRecommendations() {
    if (this.productId === undefined || this.token === undefined)
      return;
    search_store.searchState.loading = true;
    const campaignType = this.campaignType.length > 0 ? this.campaignType : "VPR";
    const headers = createBearAuthedHeader(this.token);
    const body = index$1.getRecommendationsBody({
      productId: this.productId,
      color: this.color,
      excluded: this.excluded,
      campaigns: this.campaigns,
      dynamicFilters: this.requestDynamicFilters,
    });
    const request = search_store._function.pipe(search_store.TaskEither.of(getRecommendationsService(campaignType)), search_store.TaskEither.ap(search_store.TaskEither.of(body)), search_store.TaskEither.ap(search_store.TaskEither.of(headers)), search_store.TaskEither.flatten);
    const runRequest = await request();
    search_store._function.pipe(runRequest, search_store.Either.fold((error) => {
      this.handleError(error);
      this.vviinnNoResult.emit(this.getBasicEventData());
      this.vviinnRecommendationsLoaded.emit();
      search_store.searchState.loading = false;
    }, (data) => {
      this.handleRecommendationsSuccess(data);
      search_store.searchState.loading = false;
    }));
  }
  handleError(_) {
    this.hasErrorOnLoad = true;
  }
  handleRecommendationsSuccess({ data, interactions, }) {
    this.vviinnResultLoad.emit(this.getBasicEventData());
    this.trackResultEvent("load");
    this.dynamicFilters =
      interactions.dynamicFilters;
    const { products, sourceProduct } = data;
    this.recommendations = products;
    this.sourceProduct = sourceProduct;
    search_store.searchState.results = this.recommendations;
    search_store.searchState.sourceProduct = this.sourceProduct;
    this.productIds = this.recommendations.map((r) => r.productId);
    this.productImageLoadedSubject.subscribe((id) => {
      this.productIds = this.productIds.filter((x) => x !== id);
      if (!this.isSetMode && this.productIds.length === 0)
        this.vviinnRecommendationsLoaded.emit();
      if (this.isSetMode) {
        const setModeProductsLoaded = this.productIds.length === this.recommendations.length - 4;
        if (setModeProductsLoaded)
          this.vviinnRecommendationsLoaded.emit();
      }
    });
  }
  isExternalCSS() {
    return this.cssUrl && this.cssUrl.length > 0;
  }
  renderExternalCSS() {
    return this.isExternalCSS() ? (index.h("link", { href: this.cssUrl, rel: "stylesheet" })) : ("");
  }
  render() {
    if (this.recommendations.length === 0 && this.noResultShow === false)
      return null;
    return (index.h(index.Host, { class: {
        loaded: true,
        empty: this.recommendations.length == 0,
        [this.mode]: true,
      }, "aria-hidden": "false" }, index.h(index.Fragment, null, this.renderExternalCSS(), _package.SlotSkeleton("vpr"), index.h("style", null, search_store.state.fallbackStyles), index.h("div", { class: "widget-header" }, index.h("div", null, index.h("h2", { part: "recommendations-title" }, index.h("slot", { name: "vviinn-recommendations-title" }, this.isSetMode
      ? index$2.instance.t("setMode.widgetTitle")
      : this.blockTitle)), this.isSetMode && (index.h("h3", { part: "recommendations-subtitle" }, index.h("slot", { name: "vviinn-recommendations-subtitle" }, index$2.instance.t("setMode.widgetSubtitle"))))), this.isSetMode && this.updateButtonLocation !== "onItem" ? (index.h("button", { class: "update-button", part: "update-button-top", onClick: () => (this.updatingAllCards = true) }, index.h("slot", { name: "vviinn-update-button-icon" }, index.h(UpdateIcon, null)), index.h("slot", { name: "vviinn-update-button-text" }, index.h("span", null, index$2.instance.t("setMode.updateButtonText"))))) : null), (this.showFilters || this.showExtendedFilters) && (index.h("div", { class: "filters-header " }, this.showFilters && (index.h("vviinn-filters", { filters: this.dynamicFilters })), this.showExtendedFilters && (index.h("vviinn-extended-filters", { filters: this.dynamicFilters, locale: this.locale })))), this.recommendations.length > 0 &&
      (this.useCarousel ? this.renderCarousel() : this.renderResults()), (this.recommendations.length === 0 ||
      (this.recommendations.length < 4 && this.isSetMode) ||
      this.hasErrorOnLoad) &&
      !search_store.searchState.loading && (index.h("p", { class: "no-result-text" }, this.noResultText.length
      ? this.noResultText
      : index$2.instance.t("noResultText"))))));
  }
  renderRecommendation(recommendation, index$2) {
    var _a, _b;
    return (index.h("vviinn-product-card", { part: "product-part", productId: recommendation.productId, productTitle: recommendation.title, productType: recommendation.productType, deeplink: recommendation.deeplink, image: recommendation.image.thumbnail, brand: recommendation.brand, imageWidth: this.imageWidth, imageRatio: this.imageRatio, price: recommendation.price.actual, salePrice: recommendation.price.sale, basePrice: (_a = recommendation.basePrice) === null || _a === void 0 ? void 0 : _a.actual, baseSalePrice: (_b = recommendation.basePrice) === null || _b === void 0 ? void 0 : _b.sale, energyCertifications: recommendation.energyCertifications, addPriceContainer: this.addPriceContainer, responsive: this.isGridMode, addToBasketShow: this.addToBasketShow, campaignTypeId: this.campaignType, index: index$2, widgetElementId: this.id, widgetVersion: _package.version, currency: this.currencySign, pricePrefix: this.pricePrefix, setMode: this.isSetMode, locale: this.locale, customLabels: index$1.getCustomLabels(recommendation), favoriteShow: this.favoriteShow }));
  }
  renderResults() {
    return (index.h("div", { class: "recommendations-grid", part: "recommendations-grid" }, this.recommendations.map((r, i) => this.renderRecommendation(r, i))));
  }
  renderCarousel() {
    return (index.h("vviinn-carousel", { mode: this.mode, campaignTypeId: this.campaignType, imageWidth: this.imageWidth, showScroll: this.showScroll, recommendations: this.recommendations, widgetElementId: this.id, widgetVersion: _package.version, gridArrowsDynamic: this.gridArrowsDynamic, addToBasketShow: this.addToBasketShow, addPriceContainer: this.addPriceContainer, updatingAllCards: this.updatingAllCards, updateButtonLocation: this.updateButtonLocation, replaceSlotsContent: this.replaceSlotsContent.bind(this), setModeDiscountsArray: this.setModeDiscountsArray, currencySign: this.currencySign, pricePrefix: this.pricePrefix, locale: this.locale, imageRatio: this.imageRatio, favoriteShow: this.favoriteShow }));
  }
  get el() { return index.getElement(this); }
  static get watchers() { return {
    "productId": ["handleProductIdChange"],
    "campaignType": ["handleCampaignTypeChange"],
    "campaigns": ["handleCampaignsChange"],
    "apiPath": ["handleApiPathChange"],
    "opened": ["trackWidgetOpen"],
    "closed": ["trackWidgetClose"]
  }; }
};
VviinnVprWidget.style = vviinnVprWidgetCss;

exports.vviinn_carousel = VviinnCarousel;
exports.vviinn_energy_label = VviinnEnergyLabel;
exports.vviinn_extended_filters = VviinnExtendedFilters;
exports.vviinn_filters = VviinnFilters;
exports.vviinn_price_range = VviinnButton;
exports.vviinn_product_card = VviinnProductCard;
exports.vviinn_skeleton = VviinnSkeleton;
exports.vviinn_vpr_widget = VviinnVprWidget;
